import { DataStore, Predicates, SortDirection } from '@aws-amplify/datastore';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import AWS from "aws-sdk";
import awsmobile from "../../aws-exports";
import { Image } from 'primereact/image';
import sideBarRight from "../../assets/images/sidebarright.svg";
import { Tag } from 'primereact/tag';
import { useReactToPrint } from "react-to-print";
import logoImg from '../../assets/images/logo.png';
import moment from 'moment/moment';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from "primereact/inputtext";
import React, { Fragment, useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import { reactLocalStorage } from 'reactjs-localstorage';
import Layout from "../../components/common/nav/initiator/nav.component";
import { ConvertResponseForSelect, graphQLGetAllData, graphQLFindRecordById } from '../../helper/commonfunctions';
import { CertificatedSubInitiateRequest, CertificatedSubRequestFundingAccountDetails, CertificatedSubRequestSpecificTeacherDates, CertificatedSubRequestTeacherData, CertificatedSubRequestTransactionCycle, Employee, FundingAccountType, Schools } from '../../models';
import Login from '../../setup/auth/login.component';
import { USER_TYPES, USER_TYPES_NAMES, SUB_CERTIFICATED_STATUS } from '../../helper/enum';
import { handleNotificationsOnStatusChangeforSubstituteRequestCertificated } from '../../components/actions/notficationActions';
import { Tooltip } from 'primereact/tooltip';
import { InputNumber } from 'primereact/inputnumber';
import { API, graphqlOperation } from 'aws-amplify';
import * as mutations from '../../graphql/mutations';
import * as queries from "../../graphql/queries";
import { designationForAllApps } from '../../helper/enum';
import capitalizeFirstChar from '../../components/common/capitalizeFirstChar'
import { useSelector } from 'react-redux';
const InitiateNewSubstituteRequestCertificated = () => {

    let navigateTo = useNavigate();
    const previousRoute = useSelector((state) => state?.currentTheme?.previousRoute);
    const [pleaseWaitButton, setPleaseWaitButton] = useState('');

    const [approverFieldsDisabled, setApproverFieldsDisabled] = useState(false);

    //print report functionality
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    //pre-review 
    let [previewShow, setPreviewShow] = useState(false);
    const [allApproverList, setAllApproverList] = useState([]);
    const [showReport, setShowReport] = useState(false);
    const [globalLoggedUserId, setGloballyLoggedUserId] = useState('');
    const [isEditMode, setEditMode] = useState(false);
    var { reportId, reportStatus } = useParams();
    const [isAuthenticated, userHasAuthenticated] = useState(true);
    const [selectedSchool, setSelectedSchool] = useState(null);
    const [employeeList, setEmployeeList] = useState();
    const [schoolList, setSchoolList] = useState([]);
    const [fundingAccountTypeList, setFundingAccountTypeList] = useState([]);
    const [initiateNewReportDate, setInitiateNewReportDate] = useState(new Date());
    const [specifyPurposeValue, setSpecifyPurposeValue] = useState("");

    const [assighmentTitle, setAssighmentTitle] = useState("");
    const [firstApproverList, setFirstApproverList] = useState([]);
    const [selectedFirstApprover, setSelectedFirstApprover] = useState(null);
    const [secondApproverList, setSecondApproverList] = useState([]);
    const [finalBudgetManager, setFinalBudgetManager] = useState([]);
    const [selectedSecondApprover, setSelectedSecondApprover] = useState(null);
    const [selectedThirdApprover, setSelectedThirdApprover] = useState(null);
    const [payrollList, setPayrollList] = useState([]);
    const [selectedPayroll, setSelectedPayroll] = useState(null);
    const [openNewEmployee, setOpenNewEmployee] = useState(false);

    const [isValueChange, setIsValueChange] = useState(false)
    // const [NewEmployeeName, setNewEmployeeName] = useState('');

    const [newEmpFirstName, setNewEmpFirstName] = useState('');
    const [newEmpLastName, setNewEmpLastName] = useState('');
    const rolesArray = [
        { name: 'Initiator', code: 'I' },
        { name: 'Approver', code: 'AP' },
        { name: 'Payroll', code: 'P' },
    ];
    const [newEmpSelectedRole, setNewEmpSelectedRole] = useState(null);
    const [newEmpSelectedDesignation, setNewEmpSelectedDesignation] = useState(null);

    const [NewEmployeeCode, setNewEmployeeCode] = useState('');
    const [NewEmployeeEmail, setNewEmployeeEmail] = useState('');
    const loggedUserId = reactLocalStorage.get('loggedUserId');
    const lastPart = reactLocalStorage.get('lastPart');
    const [isMasterDataLoaded, setIsMasterDataLoaded] = useState(false);
    const [allEmployeeList, setAllEmployeeList] = useState([]);
    const [employeeUniqList, setEmployeeUniqList] = useState([]);


    const [isDisableSiteAdmin,setISDisableSiteAdmin] = useState(false);
    const [isDisableBudgetClerk,setISDisableBudgetClerk] = useState(false);
    const [isDisableBudgetManager,setISDisableBudgetManager] = useState(false);

   


    //set static payroll hr-subcalendar@gusd.net(Prevous email) - changed email(payroll.info@gusd.net)
    const payrollEmail = process.env.REACT_APP_Certificated_Email;
    const [searchPayroll, setSearchPayroll] = useState(payrollEmail);

    // const [selectedEmployee, setSelectedEmployee] = useState(null);
    // const [gradeOrSubjectValue, setGradeOrSubjectValue] = useState("");
    // const [noteValue, setNoteValue] = useState("");
    // const [teacherDates, setTeacherDates] = useState(null);
    // const [selectedFundingAccount, setSelectedFundingAccount] = useState(null);
    // const [accountNumberValue, setAccountNumberValue] = useState('');
    // const [selectedIndicateIf, setSelectedIndicateIf] = useState(null);

    const [clerkList, setClerkList] = useState([]);
    const [managerList, setManagerList] = useState([]);

    const [budgetClerkList, setBudgetClerkList] = useState([]);
    const [budgetManagerList, setBudgetManagerList] = useState([]);
    const clearBudgetClerkField = (e) => {
        e.preventDefault();
        setSelectedSecondApprover(null)
        setSelectedThirdApprover(null);
    };
    var selectedBudgeClerkTemplate = (option, props) => {
        if (option) {
            return <div className="flex w-full justify-between"><p>{option.name ? (option.name).length > 35 ? (option.name).substring(0, 35) : option.name : null}</p><p onClick={clearBudgetClerkField}><i className="pi pi-times" style={{ fontSize: '1vw' }}></i></p></div>
        }
        return <span>{props.placeholder}</span>
    }
    //set Roving Substitute email 
    const [rovingSubstituteEmail, setRovingSubstituteEmail] = useState(process.env.REACT_APP_ROVINGSUBS_Email);
    const [certificatedSubReqIsSuperadmin, setCertificatedSubReqIsSuperadmin] = useState(0);

    const inputRef1 = useRef(null);
    const inputRef2 = useRef(null);

    const openCalendar = type => {
        if (inputRef1.current && type === "DatesNeeded") {
            inputRef1.current.focus();
        } else if (inputRef2.current && type === "submittedOn") {
            inputRef2.current.focus();
        }
        else {
            console.log("error");
        }
    };

    const checkApplicationAccessibility = () => {
        //six-period
       
        let certificatedSubReqIsSuperadmin = reactLocalStorage.get("isSubCertSAdmin");

        setCertificatedSubReqIsSuperadmin(certificatedSubReqIsSuperadmin)
    };

    const indicateIfList = [
        { name: 'AM', code: 'AM' },
        { name: 'PM', code: 'PM' },
        { name: 'Full', code: 'Full' },
    ];

    //Add more
    const [countTeacherDetails, setCountTeacherDetails] = useState(1);
    const [teachers, setTeachers] = useState([
        { teacherName: '', datesNeeded: [], indicateIf: '', gradeOrSubject: '', note: '' }
    ]);

    useEffect(() => {
        console.log('teachers 😂😋🕑', teachers)
    }, [teachers])


    //get unique emplyee lists
    const getUniqueEmployeeList = async (employeeResponses) => {
        // Grouping by email of employee in the school
        const groupedByEmail = employeeResponses.reduce((acc, obj) => {
            const email = obj.email;
            if (!acc[email]) {
                acc[email] = [];
            }
            acc[email].push(obj);

            return acc;
        }, {});

        console.log(groupedByEmail, "groupedByEmail")
        // Order each group by createdAt date in descending order
        for (const email in groupedByEmail) {
            groupedByEmail[email].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        }
        // Create a list with unique email addresses and the latest object for each email
        const uniqueEmailList = Object.keys(groupedByEmail).map((email) => groupedByEmail[email][0]);

        // Display the result
        console.log(uniqueEmailList, "uniqueEmailList1");
        return uniqueEmailList;
    }

    const removeDiv = (index) => {
        // Create a copy of the array to avoid modifying the state directly
        let updatedArray = [...teachers];
        // Use splice to remove the element at the specified index
        updatedArray.splice(index, 1);
        updatedArray = updatedArray.sort((a, b) => a.teacherName.name.localeCompare(b.teacherName.name));
        // Update the state with the modified array
        setTeachers(updatedArray);
    };

    const [countFundingAccountDetails, setCountFundingAccountDetails] = useState(1);
    const [fundingAccounts, setFundingAccounts] = useState([
        { fundingAccount: '', programAccountNumber: '', remarks: '', percentageValue: '' }
    ]);
    const fetchPaginatedRecords = async (query, filter, sort, limit, resultKey, checkDeleted = true) => {
        let allRecords = [];
        let nextToken = null;
        let variables = checkDeleted ? { _deleted: { eq: null } } : {};
        // Add to query variables that are not null
        filter && (variables.filter = filter);
        limit && (variables.limit = 3000);
        sort && (variables.sort = sort);
        do {
            variables.nextToken = nextToken;
            const result = await API.graphql(graphqlOperation(query, variables));
            const { items, nextToken: newNextToken } = result.data[resultKey];

            allRecords = [...allRecords, ...items];
            nextToken = newNextToken;
        } while (nextToken);
        return allRecords.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
    };

    //Roving substitute
    async function loadRovingUsers() {

        try {

            var employeeRoving = await graphQLGetAllData("listEmployees", [{ email: { eq: rovingSubstituteEmail } }])
            if (employeeRoving.length) {
                let name = employeeRoving[0].employee_code ? `${employeeRoving[0].employee_name} (${employeeRoving[0].employee_code})` : employeeRoving[0].employee_name;
                let obj = {
                    name: name,
                    code: employeeRoving[0].id
                }
                //setRovingSubstitute(obj);
                return obj;
            }

        } catch (e) {
        }
    }

    const SaveUserToCognito = async (newEmployeeId) => {
        const cognito = new AWS.CognitoIdentityServiceProvider();
        const userPoolId = awsmobile.aws_user_pools_id;
        const username = NewEmployeeEmail
        const password = "Gusd@2023"
        const Permanent = true

        let attributes = [
            {
                Name: 'email',
                Value: NewEmployeeEmail
            },
            {
                Name: 'custom:firstName',
                Value: newEmpFirstName
            },
            {
                Name: 'custom:lastName',
                Value: newEmpLastName
            },
            {
                Name: 'name',
                // Value: NewEmployeeName
                Value: capitalizeFirstChar(newEmpLastName) + ", " + newEmpFirstName.toUpperCase()
            },
            {
                Name: 'custom:userCode',
                Value: NewEmployeeCode
            },
            // {
            //     Name: 'custom:city',
            //     Value: city
            // },
            // {
            //     Name: 'custom:mobileNumber',
            //     Value: phoneNo
            // },
            // {
            //     Name: 'custom:address',
            //     Value: addressOne
            // },
            // {
            //     Name: 'custom:stateId',
            //     Value: state
            // },
            // {
            //     Name: 'custom:countryId',
            //     Value: country
            // },
            // {
            //     Name: 'custom:userType',
            //     Value: userType.label
            // },
            {
                Name: 'custom:empId',
                Value: newEmployeeId
            },

        ];

        const params = {
            UserPoolId: userPoolId,
            Username: username,
            UserAttributes: attributes
        };

        const params2 = {
            UserPoolId: userPoolId,
            Username: username,
            Password: password,
            Permanent: Permanent,
        };

        let userSub;
        try {
            const createUserResponse = await cognito.adminCreateUser(params).promise();
            console.log('Employee confirmed and saved successfully', createUserResponse);
            userSub = createUserResponse.User?.Attributes?.find(attr => attr.Name === 'sub')?.Value;
            // setUserSub(userSub);
            // toast.success("Employee confirmed and saved successfully")

            // User Confirmation 
            cognito.adminSetUserPassword(params2, (err, data) => {
                if (err) {
                    console.log('Error confirming user:', err);
                } else {
                    console.log('User confirmed successfully:', data);
                }
            });

        } catch (error) {
            toast.error("Employee already exist.")
            setOpenNewEmployee(false)
            // setNewEmployeeSchool(null);
            // setNewEmployeeName("");
            setSelectedSchool(null);
            setNewEmpFirstName("");
            setNewEmpLastName("");
            setNewEmpSelectedRole(null);
            setNewEmpSelectedDesignation(null);

            setNewEmployeeCode("");
            setNewEmployeeEmail("");
            console.error('Error saving Cognito user:', error);
        }



        if (userSub !== null) {
            //Update Employee with Cognito UserId
            const original = await API.graphql(
                graphqlOperation(queries.getEmployee,
                    { id: newEmployeeId }
                )
            );
            // await DataStore.query(Employee, newEmployeeId);
            await API.graphql(
                graphqlOperation(mutations.updateEmployee, {
                    input: {
                        id: original?.data?.getEmployee?.id,
                        user_Id: userSub,
                        _version: original?.data?.getEmployee?._version,
                    }
                }))
            // await DataStore.save(
            //     Employee.copyOf(original, (updated) => {
            //         updated.user_Id = userSub
            //     })
            // );
            // const original = await DataStore.query(Employee, newEmployeeId);
            // const original = await graphQLFindRecordById("getEmployee", newEmployeeId)

            // // Update record
            // await API.graphql({
            //     query: mutations.updateEmployee,
            //     variables: {
            //         input: {
            //             id: original.id,
            //             _version: original._version,
            //             user_Id: userSub
            //         }
            //     }
            // });

            /* await DataStore.save(
                Employee.copyOf(original, (updated) => {
                    updated.user_Id = userSub
                })
            ); */

        }


    }

    const AddNewEmployee = async () => {
        if (selectedSchool === "" || selectedSchool === null) {
            toast.error("Please Select School/Department");
            return;
        }
        // else if (NewEmployeeName === null || NewEmployeeName === "") {
        //     toast.error("Please Enter Employee Name");
        //     return;
        // }
        else if (newEmpFirstName === null || newEmpFirstName === "") {
            toast.error("Please Enter Employee First Name");
            return;
        }
        else if (newEmpLastName === null || newEmpLastName === "") {
            toast.error("Please Enter Employee Last Name");
            return;
        }

        /* else if (newEmpSelectedRole === null) {
            toast.error("Please Select Employee Role");
            return;
        }
        else if (newEmpSelectedDesignation === null) {
            toast.error("Please Select Employee Designation");
            return;
        } */


        else if (NewEmployeeCode === "") {
            toast.error("Please Enter Employee Code");
            return;
        } else if (NewEmployeeEmail === null || NewEmployeeEmail === "") {
            toast.error("Please Enter Employee Email");
            return;
        }
        // var AddedNewEmployee = await DataStore.save(new Employee(
        //     {
        //         "school_id": selectedSchool?.code,
        //         "employee_name": NewEmployeeName,
        //         "employee_code": NewEmployeeCode,
        //         "email": NewEmployeeEmail

        //     }
        // ))

        //first check typed email id is already present or not
        //const matchedEmailRecord = await graphQLGetAllData("listEmployees", [{ email: { eq: NewEmployeeEmail } }])
        // const matchedEmailRecord = await graphQLGetAllData("listEmployees", [{ email: { eq: NewEmployeeEmail } },{ school_id: { eq: selectedSchool?.code } }])
        // console.log(matchedEmailRecord.length,"matchedEmailRecord.length")
        const matchedEmailRecord = await graphQLGetAllData("listEmployees", [{ email: { eq: NewEmployeeEmail } }])
        console.log(matchedEmailRecord.length, "matchedEmailRecord.length")
        const matchedEmailSchool = matchedEmailRecord.filter(item => item.school_id === selectedSchool?.code)
        console.log(matchedEmailSchool.length, "matchedEmailSchool.length")


        if (matchedEmailSchool.length == 0) {

            let newEmployee = await API.graphql(
                graphqlOperation(mutations.createEmployee, {
                    input: {
                        school_id: selectedSchool?.code,
                        firstName: newEmpFirstName.toUpperCase(),
                        lastName: capitalizeFirstChar(newEmpLastName),
                        employee_name: capitalizeFirstChar(newEmpLastName) + ", " + newEmpFirstName.toUpperCase(),
                        // employee_name: newEmpLastName.toLowerCase() + ", " + newEmpFirstName.toUpperCase(),
                        /* role: newEmpSelectedRole?.code,
                            designation: newEmpSelectedDesignation.code, */
                        // employee_name: NewEmployeeName,
                        employee_code: NewEmployeeCode,
                        email: NewEmployeeEmail
                    }
                })
            );

            if (newEmployee?.data?.createEmployee?.id !== null) {
                if (matchedEmailRecord.length === 0) {
                    //Save Cognito User
                    await SaveUserToCognito(newEmployee?.data?.createEmployee?.id);
                }
            }

            if (newEmployee) {
                toast.success('Data Added Successfully.');
                try {
                    // var employeeResponses = await DataStore.query(Employee, (c) => c.school_id.eq(AddedNewEmployee?.school_id),
                    //     {
                    //         sort: s => s.employee_name(SortDirection.ASCENDING),
                    //     }
                    // );
                    var employeeListArray = await fetchPaginatedRecords(
                        queries.listEmployees,
                        { school_id: { eq: newEmployee?.data?.createEmployee?.school_id } },
                        { field: "employee_name", direction: "asc" },
                        1000,
                        'listEmployees'
                    );
                    // let employeeListArray = await graphQLGetAllData("listEmployees", [{ school_id: { eq: selectedSchool?.code } }])
                    // employeeListArray = employeeListArray.sort((a, b) => (a.employee_name?.toLowerCase() ?? "").localeCompare(b.employee_name?.toLowerCase() ?? ""));

                    // let employeeListArray = selectedSchool?.code ? allEmployeeList.filter(e => e.school_id && e.school_id.includes(selectedSchool?.code)) : allEmployeeList;

                    if (employeeListArray.length) {
                        employeeListArray = await getUniqueEmployeeList(employeeListArray)
                        let employee = [];
                        //push roving substitute
                        let rovingSubstituteuser = await loadRovingUsers();
                        //console.log(rovingSubstituteuser,"rovingSubstituteuser")
                        if (rovingSubstituteuser) {
                            employee.push(rovingSubstituteuser)
                        }
                        employeeListArray.map((item) => {
                            let name = item.employee_code ? `${item.employee_name} (${item.employee_code})` : item.employee_name;
                            let obj = {
                                name: name,
                                code: item.id
                            }
                            employee.push(obj);
                        })

                        setEmployeeList(employee);
                    }
                }
                catch (error) {
                    console.log('error', error)
                }

                let obj = {
                    // name: (NewEmployeeName + ' ' + '(' + NewEmployeeCode + ')'),
                    name: (capitalizeFirstChar(newEmpLastName) + ", " + newEmpFirstName.toUpperCase() + ' ' + '(' + NewEmployeeCode + ')'),
                    code: newEmployee.data.createEmployee.id
                }
                let updatedTeachers = [...teachers];
                updatedTeachers[0].teacherName = obj;
                updatedTeachers = updatedTeachers.sort((a, b) => a.teacherName.localeCompare(b.teacherName));
                setTeachers(updatedTeachers);

                // setSelectedEmployee(obj);
                setOpenNewEmployee(false)
                // setNewEmployeeName("");
                setNewEmpFirstName("");
                setNewEmpLastName("");
                setNewEmpSelectedRole(null);
                setNewEmpSelectedDesignation(null);

                setNewEmployeeCode("");
                setNewEmployeeEmail("");
            }
        } else {
            toast.error("Please Use Another Email");
        }

    }
    const removeDivFun = (index) => {
        // Create a copy of the array to avoid modifying the state directly
        const updatedArrayFun = [...fundingAccounts];

        // Use splice to remove the element at the specified index
        updatedArrayFun.splice(index, 1);

        // Update the state with the modified array
        setFundingAccounts(updatedArrayFun);
    };

    async function setUserList(e) {
        try {
            // var employeeResponses = await DataStore.query(Employee, Predicates.ALL, {
            //     sort: s => s.employee_name(SortDirection.ASCENDING)
            // });

            if (employeeUniqList.length) {
                let employee = [];
                employeeUniqList.map((item) => {
                    let name = item.employee_code ? `${item.employee_name} (${item.employee_code})` : item.employee_name;
                    let obj = {
                        name: name,
                        code: item.user_Id

                    }
                    employee.push(obj);

                })
                if (e) {
                    let employeeSearchData = [];
                    employeeSearchData = employee.filter(item => item.employee_code === e.target.value);
                    employeeSearchData = employee.filter(item => item.employee_name === e.target.value);
                    setAllApproverList(employee)
                } else {
                    setAllApproverList(employee)
                }
            }
        }
        catch (error) {
            console.log(error)
        }
    }

    //budget clerk
    async function setUserListByClerk(e) {
        try {

            let clerkList = employeeUniqList.filter(item => item.designation === "BUDGET_CLERK")
            if (clerkList.length) {
                let employee = [];
                clerkList.map((item) => {
                    let name = item.employee_code ? `${item.employee_name} (${item.employee_code})` : item.employee_name;
                    let obj = {
                        name: name,
                        code: item.user_Id
                    }
                    employee.push(obj);

                })
                if (e) {
                    let employeeSearchData = [];
                    employeeSearchData = employee.filter(item => item.employee_code === e.target.value);
                    employeeSearchData = employee.filter(item => item.employee_name === e.target.value);

                    setBudgetClerkList(employee)
                } else {
                    setBudgetClerkList(employee)
                }
            }
        }
        catch (error) {
            console.log(error)
        }
    }

    //budget manager
    async function setUserListByManager(e) {
        try {

            let managerList = employeeUniqList.filter(item => item.designation === "BUDGET_MANAGER")
            if (managerList.length) {
                let employee = [];
                managerList.map((item) => {
                    let name = item.employee_code ? `${item.employee_name} (${item.employee_code})` : item.employee_name;
                    let obj = {
                        name: name,
                        code: item.user_Id
                    }
                    employee.push(obj);

                })
                if (e) {
                    let employeeSearchData = [];
                    employeeSearchData = employee.filter(item => item.employee_code === e.target.value);
                    employeeSearchData = employee.filter(item => item.employee_name === e.target.value);

                    setBudgetManagerList(employee)
                } else {
                    setBudgetManagerList(employee)
                }
            }
        }
        catch (error) {
            console.log(error)
        }
    }

    const handleAddClick = (divType) => {
        let Percentage;
        fundingAccounts.map((data, i) => {
            Percentage = data.percentageValue;
        })

        if (divType == 'teacherDiv') {

            let lastElement = teachers.length - 1;

            //check teachers array last element mandatory fields are filed or not.
            if (teachers[lastElement].teacherName === '') { toast.error('Please Select Teacher'); return; }
            else if (teachers[lastElement].datesNeeded.length < 1) { toast.error('Please Select Date'); return; }
            else if (teachers[lastElement].indicateIf === '') { toast.error('Please Select Indicate If'); return; }
            else if (teachers[lastElement].note === '') { toast.error('Please Enter Notes'); return; }
            // else if (teachers[lastElement].gradeOrSubject === '') { toast.error('Please Enter Grade or Subject'); return; }
            // else if (teachers[lastElement].note === '') { toast.error('Please Enter Note'); return; }
            setCountTeacherDetails(countTeacherDetails + 1);
            setTeachers([...teachers, { teacherName: '', datesNeeded: [], indicateIf: '', gradeOrSubject: '', note: '' }]);
        } else {

            //check teachers array last element mandatory fields are filed or not.
            let lastElement = fundingAccounts.length - 1;

            if (fundingAccounts[lastElement].fundingAccount === '') { toast.error('Please Select funding account type'); return; }
            else if (fundingAccounts[lastElement].programAccountNumber === '') { toast.error('Please Enter account Number'); return; }
            else if (Percentage > 100) { toast.error('Percentage cannot be greater than 100'); return; }

            setCountFundingAccountDetails(countFundingAccountDetails + 1);
            setFundingAccounts([...fundingAccounts, { fundingAccount: '', programAccountNumber: '' }]);
        }
    };

    //Teacher Details Change Functions start
    const handleTeacherNameChange = (index, e) => {
        const updatedTeachers = [...teachers];
        updatedTeachers[index].teacherName = e.value;
        setTeachers(updatedTeachers);
    };
    const handleTeacherNeededDatesChange = (index, e) => {
        const updatedTeachers = [...teachers];
        updatedTeachers[index].datesNeeded = e.value;
        setTeachers(updatedTeachers);
    }
    const handleTeacherIndicatesIfChange = (index, e) => {
        const updatedTeachers = [...teachers];
        updatedTeachers[index].indicateIf = e.value;
        setTeachers(updatedTeachers);
    }
    const handleTeacherGradeOrSubjectChange = (index, e) => {
        const updatedTeachers = [...teachers];
        updatedTeachers[index].gradeOrSubject = e.target.value;
        setTeachers(updatedTeachers);
    }
    const handleTeacherNotesChange = (index, e) => {
        const updatedTeachers = [...teachers];
        updatedTeachers[index].note = e.target.value;
        setTeachers(updatedTeachers);
    }
    //Teacher Details Change Functions end.

    //Funding Account Details Change Functions start
    const handleSelectFundingAccountChange = (index, e) => {
        const updatedFundingAccounts = [...fundingAccounts];
        updatedFundingAccounts[index].fundingAccount = e.value;
        setFundingAccounts(updatedFundingAccounts);
    };

    const handleSelectRemarkChange = (index, e) => {
        const updatedFundingAccounts = [...fundingAccounts];
        updatedFundingAccounts[index].remarks = e.target.value;
        setFundingAccounts(updatedFundingAccounts);
    };
    const handleProgramAccountNumberChange = (index, e) => {
        const updatedFundingAccounts = [...fundingAccounts];
        updatedFundingAccounts[index].programAccountNumber = e.target.value;
        setFundingAccounts(updatedFundingAccounts);
    };

    const handlePercentageChange = (index, e) => {
        const updatedFundingAccounts = [...fundingAccounts];
        // updatedFundingAccounts[index].percentageValue = String(e.value);
        updatedFundingAccounts[index].percentageValue = e.value;
        setFundingAccounts(updatedFundingAccounts);
    };
    //Funding Account Details Change Functions end.


    // dialog states
    const [confirmInitiateNewReport, setConfirmInitiateNewReport] = useState(false);

    const getSpecificSchoolOrDeptEmployees = async (e) => {

        let selectedSchoolOrDeptId = e.value.code;
        setSelectedSchool(e.value);

        try {
            // var employeeResponses = await DataStore.query(Employee, (c) => c.school_id.eq(selectedSchoolOrDeptId),
            //     {
            //         sort: s => s.employee_name(SortDirection.ASCENDING),
            //     }
            // );

            let employeeListArray = allEmployeeList.filter(e => e.school_id && e.school_id.includes(selectedSchoolOrDeptId))

            if (employeeListArray.length > 0) {


                employeeListArray = employeeListArray.filter(e => e._deleted !== true)


                employeeListArray = await getUniqueEmployeeList(employeeListArray);

                let employee = [];
                //push roving substitute
                let rovingSubstituteuser = await loadRovingUsers();
                //console.log(rovingSubstituteuser,"rovingSubstituteuser")
                if (rovingSubstituteuser) {
                    employee.push(rovingSubstituteuser)
                }
                employeeListArray.map((item) => {
                    let name = item.employee_code ? `${item.employee_name} (${item.employee_code})` : item.employee_name;
                    let obj = {
                        name: name,
                        code: item.id
                    }
                    employee.push(obj);
                })

                setEmployeeList(employee);
            }
        }
        catch (error) {
            console.log("Error in getSpecificSchoolOrDeptEmployees", error);
        }
    }


    /* const onSelectFirstApprover = (e) => {
        setSelectedFirstApprover(e.value);

        //when first approver select then second approver list visible.
        let finalSecondApprovers = [];
        allApproverList.map((currentUser) => {
            if (currentUser.code != e.value.code) {
                finalSecondApprovers.push(currentUser);
            }
        }) 

        // setAllApproverList(finalSecondApprovers);
        // setSecondApproverList(finalSecondApprovers);
        // setFinalBudgetManager(finalSecondApprovers);
        //setPayrollList(finalSecondApprovers);
    } */

    //search cognitousers
    /* const setEmpList = async (e, listName) => {
        try {
            const cognito = new AWS.CognitoIdentityServiceProvider();

            var params =
            {
                UserPoolId: awsmobile.aws_user_pools_id,
                Limit: 60,
                "Filter": "name ^= \"" + e.target.value + "\""
            };

            await cognito.listUsers(params, (err, data) => {
                if (err) {
                    //(err.message);
                } else {
                    let usersData = []
                    //let adminUsers = data.Users
                    var role = "";
                    var name = "";
                    var sub = "";
                    var email = "";
                    var usercode = "";

                    data.Users.forEach((user, i) => {
                        role = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
                        name = user.Attributes.find(attr => attr.Name === "name")?.Value;
                        sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
                        email = user.Attributes.find(attr => attr.Name === "email")?.Value;
                        usercode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
                        name = usercode ? `${name} (${usercode})` : name;
                        let newUser = {
                            "code": sub,
                            "name": name,
                            "email": email,
                            "role": role === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : role === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : role === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
                        }

                        usersData.push(newUser)

                        if (i === data.Users.length - 1) {

                            switch (listName) {
                                case 'FirstApprover':
                                    usersData = usersData.filter(item => item.role !== "ADMIN" && item.code !== loggedUserId);
                                    setFirstApproverList(usersData);
                                    break;
                                case 'SecoundApprover':
                                    usersData = usersData.filter(item => item.role !== "ADMIN" && item.code !== loggedUserId);
                                    setSecondApproverList(usersData);
                                    break;
                                case 'ThirdApprover':
                                    usersData = usersData.filter(item => item.role !== "ADMIN" && item.code !== loggedUserId);
                                    setFinalBudgetManager(usersData);
                                    break;
                                case 'payroll':
                                    usersData = usersData.filter(item => item.role !== "ADMIN" && item.code !== loggedUserId);
                                    // setPayrollList(usersData);
                                    break;
                                default:
                                    usersData = usersData.filter(item => item.role !== "ADMIN" && item.code !== loggedUserId);
                                    // setPayrollList(usersData);
                                    break;


                            }
                            // if(listName === 'approvalOneList'){
                            // usersData = usersData.filter(item => item.role !== "ADMIN" && item.code !== loggedUserId);
                            // setApprovalOneList(usersData);
                            // }else if(listName === 'approvalOneList'){
                            // let approverRoleList = usersData.filter(item => item.role === USER_TYPES_NAMES.AP);
                            // setAllUsersList(approverRoleList)
                            // }
                        }
                        //usersData.push({ firstName: userFirstName, lastName: userLastName, label: userFirstName + " " + userLastName, value: adminUsers[i].Username });
                    })




                }
            });


        } catch (e) {
            //toast.error(e.message);
        }
    } */

    //onSubmit Click Function start.
    const saveInitiateNewReportInfo = async (status) => {
        let Percentage;
        fundingAccounts.map((data, i) => {
            Percentage = data.percentageValue;
        })
        //Validation check code start.
        //check teachers and funding type array last element mandatory fields are filed or not.
        let lastElementTeacher = teachers.length - 1;
        let lastElementFundingAccount = fundingAccounts.length - 1;

        if (specifyPurposeValue === "" || specifyPurposeValue === undefined) { toast.error('Please Enter Specify Purpose.'); return; }


        if (assighmentTitle === "" || assighmentTitle === null || assighmentTitle === undefined) { toast.error('Please Enter Assignment Title'); return; }
        else if (selectedSchool === null) { toast.error('Please Select School'); return; }
        else if (initiateNewReportDate === null) { toast.error('Please Date'); return; }
        else if (selectedFirstApprover === null) { toast.error('Please Select Site Admin/Dept Head'); return; }
        else if (teachers[lastElementTeacher].teacherName === '') { toast.error('Please Select Teacher'); return; }
        else if (Percentage > 100) { toast.error('Percentage cannot be greater than 100'); return; }
        //if user select second approver then third approver is mandatory
        if (selectedSecondApprover) {
            // if (selectedThirdApprover === null) { toast.error('Please Select Budget Manager'); return; }
            // else if (teachers[lastElementTeacher].teacherName === '') { toast.error('Please Select Teacher'); return; }
            if (teachers[lastElementTeacher].teacherName === '') { toast.error('Please Select Teacher'); return; }
            else if (teachers[lastElementTeacher].indicateIf === '') { toast.error('Please Select Indicate If'); return; }
            else if (teachers[lastElementTeacher].datesNeeded.length < 1) { toast.error('Please Select Date'); return; }
            else if (teachers[lastElementTeacher].note === '') { toast.error('Please Enter Notes'); return; }
            else if (fundingAccounts[lastElementFundingAccount].fundingAccount === '') {
                toast.error('Please Select funding account type');
                return;
            } else if (fundingAccounts[lastElementFundingAccount].programAccountNumber === '') {
                toast.error('Please Enter account Number');
                return;
            }
            // else if (selectedPayroll === null) { toast.error('Please Select Sub Desk (Payroll)'); return; }
        }
        // else if (selectedPayroll === null) { toast.error('Please Select Sub Desk (Payroll)'); return; }
        //else if (specifyPurposeValue === '') { toast.error('Please Enter Purpose Of Report'); return; }
        else if (teachers[lastElementTeacher].teacherName === '') { toast.error('Please Select Teacher'); return; }
        else if (teachers[lastElementTeacher].indicateIf === '') { toast.error('Please Select Indicate If'); return; }
        else if (teachers[lastElementTeacher].datesNeeded.length < 1) { toast.error('Please Select Date'); return; }
        else if (teachers[lastElementTeacher].note === '') { toast.error('Please Enter Notes'); return; }

        else if (fundingAccounts[lastElementFundingAccount].fundingAccount === '') {
            toast.error('Please Select funding account type');
            return;
        } else if (fundingAccounts[lastElementFundingAccount].programAccountNumber === '') {
            toast.error('Please Enter account Number');
            return;
        }

        //Validation check code end.

        if (status === "PENDING") {

            if(reportStatus=="copyReport"){
                try {
                   
                    const CertificatedSubInitiateRequestResponse = await API.graphql(
                        graphqlOperation(mutations.createCertificatedSubInitiateRequest, {
                            input: {
                                schoolOrDeptId: selectedSchool?.code,
                                reportDate: moment(initiateNewReportDate).format("YYYY-MM-DD"),
                                purposeOfReport: specifyPurposeValue,
                                status: status,
                                assighmentTitle: assighmentTitle,
                                submittedBy: globalLoggedUserId,
                                submittedOn: moment().format("YYYY-MM-DD"),
                                firstApproverId: selectedFirstApprover?.code,
                                secondApproverId: selectedSecondApprover === null ? null : selectedSecondApprover?.code,
                                thirdApproverId: selectedThirdApprover === null ? null : selectedThirdApprover?.code,
                                payrollId: selectedPayroll?.code
                            }
                        })
                    );

                    //after that we save data into CertificatedSubRequestTeacherData table.
                    if (CertificatedSubInitiateRequestResponse) {

                        //we call this code teachers count time.
                        for (let i = 0; i < teachers.length; i++) {
                           
                            const CertificatedSubRequestTeacherDataResponse = await API.graphql(
                                graphqlOperation(mutations.createCertificatedSubRequestTeacherData, {
                                    input: {
                                        reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                                        teacherId: teachers[i].teacherName?.code,
                                        indicateIf: teachers[i].indicateIf?.name,
                                        gradeOrSubject: teachers[i].gradeOrSubject,
                                        note: teachers[i].note
                                    }
                                })
                            );

                            //we save particular teacher dates in CertificatedSubRequestSpecificTeacherDates
                            let dateArray = teachers[i].datesNeeded;
                            if (CertificatedSubRequestTeacherDataResponse) {
                                for (let j = 0; j < dateArray.length; j++) {

                                    await API.graphql(
                                        graphqlOperation(mutations.createCertificatedSubRequestSpecificTeacherDates, {
                                            input: {
                                                teacherId: CertificatedSubRequestTeacherDataResponse.data.createCertificatedSubRequestTeacherData.id,
                                                date: moment(dateArray[j]).format("YYYY-MM-DD")
                                            }
                                        })
                                    );

                                }
                            }

                        }

                        //we call this funding account details count time.
                        for (let k = 0; k < fundingAccounts.length; k++) {
                            //save details in CertificatedSubRequestFundingAccountDetails table
                          
                            await API.graphql(
                                graphqlOperation(mutations.createCertificatedSubRequestFundingAccountDetails, {
                                    input: {
                                        reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                                        fundingAccountTypeId: fundingAccounts[k].fundingAccount?.code,
                                        accountNumber: fundingAccounts[k].programAccountNumber,
                                        remarks: fundingAccounts[k]?.remarks,
                                        noteIfSpecify: '',
                                        percentage: fundingAccounts[k]?.percentageValue,
                                    }
                                })
                            );

                        }
                        
                        setPleaseWaitButton(false);
                        toast.success('The form has been cloned.');
                        navigateTo("/substitute_request_certificated");
                        // navigateTo('/substitute_request_certificated/initiate_new_report/' + CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id + '/Pending');
                    }
                } catch (error) {
                    console.log('Error saving CertificatedSubInitiateRequestResponse', error);
                }

            }else{

            if (reportId) {

                try {
                    // const originalCertificatedSubInitiateRequest = await DataStore.query(CertificatedSubInitiateRequest, reportId);
                    const originalCertificatedSubInitiateRequest = await graphQLFindRecordById("getCertificatedSubInitiateRequest", reportId)

                    // const updatedPost = await DataStore.save(
                    //     CertificatedSubInitiateRequest.copyOf(originalCertificatedSubInitiateRequest, updated => {
                    //         updated.schoolOrDeptId = selectedSchool?.code;
                    //         updated.reportDate = moment(initiateNewReportDate).format("YYYY-MM-DD");
                    //         updated.purposeOfReport = specifyPurposeValue;
                    //         updated.status = status;
                    //         updated.assighmentTitle = assighmentTitle;
                    //         updated.submittedBy = globalLoggedUserId;
                    //         updated.submittedOn = moment().format("YYYY-MM-DD");
                    //         updated.firstApproverId = selectedFirstApprover?.code;
                    //         updated.secondApproverId = selectedSecondApprover?.code;
                    //         updated.payrollId = selectedPayroll?.code;
                    //     })
                    // );
                    const updatedPost = await API.graphql({
                        query: mutations.updateCertificatedSubInitiateRequest,
                        variables: {
                            input: {
                                id: originalCertificatedSubInitiateRequest.id,
                                _version: originalCertificatedSubInitiateRequest._version,
                                schoolOrDeptId: selectedSchool?.code,
                                reportDate: moment(initiateNewReportDate).format("YYYY-MM-DD"),
                                purposeOfReport: specifyPurposeValue,
                                status: status,
                                assighmentTitle: assighmentTitle,
                                submittedBy: globalLoggedUserId,
                                submittedOn: moment().format("YYYY-MM-DD"),
                                firstApproverId: selectedFirstApprover?.code,
                                secondApproverId: selectedSecondApprover === null ? null : selectedSecondApprover?.code,
                                thirdApproverId: selectedThirdApprover === null ? null : selectedThirdApprover?.code,
                                payrollId: selectedPayroll?.code
                            }
                        }
                    });


                    //after that we update data from CertificatedSubRequestTeacherData table with reprtId.
                    if (updatedPost.data.updateCertificatedSubInitiateRequest) {
                        //first delete all teacher and funding account which report id is same.
                        // const toDeleteCertificatedSubRequestTeacherData = await DataStore.query(CertificatedSubRequestTeacherData, c => c.reportId.eq(updatedPost.data.updateCertificatedSubInitiateRequest.id));

                        const toDeleteCertificatedSubRequestTeacherData = await graphQLGetAllData("listCertificatedSubRequestTeacherData", [{ reportId: { eq: updatedPost.data.updateCertificatedSubInitiateRequest.id } }])


                        // const toDeleteCertificatedSubRequestFundingAccountDetails = await DataStore.query(CertificatedSubRequestFundingAccountDetails, c => c.reportId.eq(updatedPost.data.updateCertificatedSubInitiateRequest.id));

                        const toDeleteCertificatedSubRequestFundingAccountDetails = await graphQLGetAllData("listCertificatedSubRequestFundingAccountDetails", [{ reportId: { eq: updatedPost.data.updateCertificatedSubInitiateRequest.id } }])

                        for (let delItem = 0; delItem < toDeleteCertificatedSubRequestTeacherData.length; delItem++) {
                            // DataStore.delete(toDeleteCertificatedSubRequestTeacherData[delItem]);
                            await API.graphql({
                                query: mutations.deleteCertificatedSubRequestTeacherData,
                                variables: {
                                    input: {
                                        id: toDeleteCertificatedSubRequestTeacherData[delItem].id,
                                        _version: toDeleteCertificatedSubRequestTeacherData[delItem]._version
                                    }
                                }
                            });

                            //after delete teacher data we delete particular teacher dates.
                            // const toDeleteCertificatedSubRequestSpecificTeacherDates = await DataStore.query(CertificatedSubRequestSpecificTeacherDates, c => c.teacherId.eq(toDeleteCertificatedSubRequestTeacherData[delItem].id));

                            const toDeleteCertificatedSubRequestSpecificTeacherDates = await graphQLGetAllData("listCertificatedSubRequestSpecificTeacherDates", [{ teacherId: { eq: toDeleteCertificatedSubRequestTeacherData[delItem].id } }])


                            for (let delDates = 0; delDates < toDeleteCertificatedSubRequestSpecificTeacherDates.length; delDates++) {
                                // DataStore.delete(toDeleteCertificatedSubRequestSpecificTeacherDates[delDates]);
                                await API.graphql({
                                    query: mutations.deleteCertificatedSubRequestSpecificTeacherDates,
                                    variables: {
                                        input: {
                                            id: toDeleteCertificatedSubRequestSpecificTeacherDates[delDates].id,
                                            _version: toDeleteCertificatedSubRequestSpecificTeacherDates[delDates]._version
                                        }
                                    }
                                });
                            }
                        }

                        for (let delFundItem = 0; delFundItem < toDeleteCertificatedSubRequestFundingAccountDetails.length; delFundItem++) {
                            // DataStore.delete(toDeleteCertificatedSubRequestFundingAccountDetails[delFundItem]);
                            await API.graphql({
                                query: mutations.deleteCertificatedSubRequestFundingAccountDetails,
                                variables: {
                                    input: {
                                        id: toDeleteCertificatedSubRequestFundingAccountDetails[delFundItem].id,
                                        _version: toDeleteCertificatedSubRequestFundingAccountDetails[delFundItem]._version
                                    }
                                }
                            });
                        }

                        //after delete teacher data add new teacher data with same report Id.
                        //we call this code teachers count time.
                        for (let i = 0; i < teachers.length; i++) {
                            // const CertificatedSubRequestTeacherDataResponse = await DataStore.save(new CertificatedSubRequestTeacherData(
                            //     {
                            //         reportId: updatedPost.data.updateCertificatedSubInitiateRequest.id,
                            //         teacherId: teachers[i].teacherName?.code,
                            //         indicateIf: teachers[i].indicateIf?.name,
                            //         gradeOrSubject: teachers[i].gradeOrSubject,
                            //         note: teachers[i].note
                            //     }
                            // ));

                            const CertificatedSubRequestTeacherDataResponse = await API.graphql(
                                graphqlOperation(mutations.createCertificatedSubRequestTeacherData, {
                                    input: {
                                        reportId: updatedPost.data.updateCertificatedSubInitiateRequest.id,
                                        teacherId: teachers[i].teacherName?.code,
                                        indicateIf: teachers[i].indicateIf?.name,
                                        gradeOrSubject: teachers[i].gradeOrSubject,
                                        note: teachers[i].note
                                    }
                                })
                            );

                            //we save particular teacher dates in CertificatedSubRequestSpecificTeacherDates
                            let dateArray = teachers[i].datesNeeded;
                            if (CertificatedSubRequestTeacherDataResponse.data) {
                                for (let j = 0; j < dateArray.length; j++) {

                                    // const CertificatedSubRequestSpecificTeacherDatesResponse = await DataStore.save(new CertificatedSubRequestSpecificTeacherDates(
                                    //     {
                                    //         teacherId: CertificatedSubRequestTeacherDataResponse.data.createCertificatedSubRequestTeacherData.id,
                                    //         date: moment(dateArray[j]).format("YYYY-MM-DD")
                                    //     }
                                    // ));

                                    await API.graphql(
                                        graphqlOperation(mutations.createCertificatedSubRequestSpecificTeacherDates, {
                                            input: {
                                                teacherId: CertificatedSubRequestTeacherDataResponse.data.createCertificatedSubRequestTeacherData.id,
                                                date: moment(dateArray[j]).format("YYYY-MM-DD")
                                            }
                                        })
                                    );

                                }
                            }

                        }

                        //we call this funding account details count time.
                        for (let k = 0; k < fundingAccounts.length; k++) {
                            //save details in CertificatedSubRequestFundingAccountDetails table
                            // await DataStore.save(new CertificatedSubRequestFundingAccountDetails(
                            //     {
                            //         reportId: updatedPost.data.updateCertificatedSubInitiateRequest.id,
                            //         fundingAccountTypeId: fundingAccounts[k].fundingAccount?.code,
                            //         accountNumber: fundingAccounts[k].programAccountNumber,
                            //         remarks: fundingAccounts[k]?.remarks,
                            //         percentage: fundingAccounts[k]?.percentageValue,
                            //         noteIfSpecify: ''
                            //     }
                            // ));

                            await API.graphql(
                                graphqlOperation(mutations.createCertificatedSubRequestFundingAccountDetails, {
                                    input: {
                                        reportId: updatedPost.data.updateCertificatedSubInitiateRequest.id,
                                        fundingAccountTypeId: fundingAccounts[k].fundingAccount?.code,
                                        accountNumber: fundingAccounts[k].programAccountNumber,
                                        remarks: fundingAccounts[k]?.remarks,
                                        percentage: fundingAccounts[k]?.percentageValue,
                                        noteIfSpecify: ''
                                    }
                                })
                            );
                        }

                        setPleaseWaitButton(false);
                        toast.success('Data Save Successfully.');
                        // navigateTo("/substitute_request_certificated");
                    }

                } catch (error) {
                    console.log('Error Updating CertificatedSubInitiateRequestResponse', error);
                }
            } else {
                //aws amplify data submit in database code start.
                try {
                    // const CertificatedSubInitiateRequestResponse = await DataStore.save(new CertificatedSubInitiateRequest(
                    //     {
                    //         schoolOrDeptId: selectedSchool?.code,
                    //         reportDate: moment(initiateNewReportDate).format("YYYY-MM-DD"),
                    //         purposeOfReport: specifyPurposeValue,
                    //         status: status,
                    //         assighmentTitle: assighmentTitle,
                    //         submittedBy: globalLoggedUserId,
                    //         submittedOn: moment().format("YYYY-MM-DD"),
                    //         firstApproverId: selectedFirstApprover?.code,
                    //         secondApproverId: selectedSecondApprover?.code,
                    //         thirdApproverId: selectedThirdApprover?.code,
                    //         payrollId: selectedPayroll?.code
                    //     }
                    // ));

                    const CertificatedSubInitiateRequestResponse = await API.graphql(
                        graphqlOperation(mutations.createCertificatedSubInitiateRequest, {
                            input: {
                                schoolOrDeptId: selectedSchool?.code,
                                reportDate: moment(initiateNewReportDate).format("YYYY-MM-DD"),
                                purposeOfReport: specifyPurposeValue,
                                status: status,
                                assighmentTitle: assighmentTitle,
                                submittedBy: globalLoggedUserId,
                                submittedOn: moment().format("YYYY-MM-DD"),
                                firstApproverId: selectedFirstApprover?.code,
                                secondApproverId: selectedSecondApprover === null ? null : selectedSecondApprover?.code,
                                thirdApproverId: selectedThirdApprover === null ? null : selectedThirdApprover?.code,
                                payrollId: selectedPayroll?.code
                            }
                        })
                    );

                    //console.log(teachers,"teachers")
                    //console.log(fundingAccounts,"fundingAccounts")

                    //console.log(CertificatedSubInitiateRequestResponse,"CertificatedSubInitiateRequestResponse")
                    //after that we save data into CertificatedSubRequestTeacherData table.
                    if (CertificatedSubInitiateRequestResponse) {

                        //we call this code teachers count time.
                        for (let i = 0; i < teachers.length; i++) {
                            // const CertificatedSubRequestTeacherDataResponse = await DataStore.save(new CertificatedSubRequestTeacherData(
                            //     {
                            //         reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                            //         teacherId: teachers[i].teacherName?.code,
                            //         indicateIf: teachers[i].indicateIf?.name,
                            //         gradeOrSubject: teachers[i].gradeOrSubject,
                            //         note: teachers[i].note
                            //     }
                            // ));

                            const CertificatedSubRequestTeacherDataResponse = await API.graphql(
                                graphqlOperation(mutations.createCertificatedSubRequestTeacherData, {
                                    input: {
                                        reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                                        teacherId: teachers[i].teacherName?.code,
                                        indicateIf: teachers[i].indicateIf?.name,
                                        gradeOrSubject: teachers[i].gradeOrSubject,
                                        note: teachers[i].note
                                    }
                                })
                            );

                            //we save particular teacher dates in CertificatedSubRequestSpecificTeacherDates
                            let dateArray = teachers[i].datesNeeded;
                            if (CertificatedSubRequestTeacherDataResponse) {
                                for (let j = 0; j < dateArray.length; j++) {

                                    // await DataStore.save(new CertificatedSubRequestSpecificTeacherDates(
                                    //     {
                                    //         teacherId: CertificatedSubRequestTeacherDataResponse.data.createCertificatedSubRequestTeacherData.id,
                                    //         date: moment(dateArray[j]).format("YYYY-MM-DD")
                                    //     }
                                    // ));

                                    await API.graphql(
                                        graphqlOperation(mutations.createCertificatedSubRequestSpecificTeacherDates, {
                                            input: {
                                                teacherId: CertificatedSubRequestTeacherDataResponse.data.createCertificatedSubRequestTeacherData.id,
                                                date: moment(dateArray[j]).format("YYYY-MM-DD")
                                            }
                                        })
                                    );

                                }
                            }

                        }

                        //we call this funding account details count time.
                        for (let k = 0; k < fundingAccounts.length; k++) {
                            //save details in CertificatedSubRequestFundingAccountDetails table
                            // await DataStore.save(new CertificatedSubRequestFundingAccountDetails(
                            //     {
                            //         reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                            //         fundingAccountTypeId: fundingAccounts[k].fundingAccount?.code,
                            //         accountNumber: fundingAccounts[k].programAccountNumber,
                            //         remarks: fundingAccounts[k]?.remarks,
                            //         noteIfSpecify: '',
                            //         percentage: fundingAccounts[k]?.percentageValue,
                            //     }
                            // ));

                            await API.graphql(
                                graphqlOperation(mutations.createCertificatedSubRequestFundingAccountDetails, {
                                    input: {
                                        reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                                        fundingAccountTypeId: fundingAccounts[k].fundingAccount?.code,
                                        accountNumber: fundingAccounts[k].programAccountNumber,
                                        remarks: fundingAccounts[k]?.remarks,
                                        noteIfSpecify: '',
                                        percentage: fundingAccounts[k]?.percentageValue,
                                    }
                                })
                            );

                        }

                        // after we add entry in CertificatedSubRequestTransactionCycle table
                        // await DataStore.save(new CertificatedSubRequestTransactionCycle(
                        //     {
                        //         reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                        //         from_Employee_Id: globalLoggedUserId,
                        //         to_Employee_Id: "-",
                        //         status: status,
                        //         isApproved: false
                        //     }
                        // ));

                        // await API.graphql(
                        //     graphqlOperation(mutations.createCertificatedSubRequestTransactionCycle, {
                        //         input: {
                        //             reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                        //             from_Employee_Id: globalLoggedUserId,
                        //             to_Employee_Id: "-",
                        //             status: status,
                        //             isApproved: false
                        //         }
                        //     })
                        // );


                        setPleaseWaitButton(false);
                        toast.success('Data Save Successfully.');

                        // if (certificatedSubReqIsSuperadmin) {
                        //     navigateTo('/substitute_request_certificated/SuperAdminDashboard');
                        // }else{
                        //     navigateTo('/substitute_request_certificated/initiate_new_report/' + CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id + '/Pending');
                        // }
                        if (previousRoute?.[0]) {
                            navigateTo(previousRoute?.[0]);
                        }else{
                            navigateTo('/substitute_request_certificated/initiate_new_report/' + CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id + '/Pending');
                        }
                        



                    }


                } catch (error) {
                    console.log('Error saving CertificatedSubInitiateRequestResponse', error);
                }
                //aws amplify data submit in database code end.
            }                
            }
        }
        else if (status === "SUBMITTED") {
            //show only for submit button
            setPleaseWaitButton(true);

            if(reportStatus==="copyReport"){
                try {
                  
                    const CertificatedSubInitiateRequestResponse = await API.graphql(
                        graphqlOperation(mutations.createCertificatedSubInitiateRequest, {
                            input: {
                                schoolOrDeptId: selectedSchool?.code,
                                reportDate: moment(initiateNewReportDate).format("YYYY-MM-DD"),
                                purposeOfReport: specifyPurposeValue,
                                assighmentTitle: assighmentTitle,
                                status: "SUBMITTED",
                                submittedBy: globalLoggedUserId,
                                submittedOn: moment().format("YYYY-MM-DD"),
                                firstApproverId: selectedFirstApprover?.code,
                                secondApproverId: selectedSecondApprover === null ? null : selectedSecondApprover?.code,
                                thirdApproverId: selectedThirdApprover === null ? null : selectedThirdApprover?.code,
                                payrollId: selectedPayroll?.code
                            }
                        })
                    );


                    //after that we save data into CertificatedSubRequestTeacherData table.
                    if (CertificatedSubInitiateRequestResponse) {

                        //we call this code teachers count time.
                        for (let i = 0; i < teachers.length; i++) {
                            const CertificatedSubRequestTeacherDataResponse = await API.graphql(
                                graphqlOperation(mutations.createCertificatedSubRequestTeacherData, {
                                    input: {
                                        reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                                        teacherId: teachers[i].teacherName?.code,
                                        indicateIf: teachers[i].indicateIf?.name,
                                        gradeOrSubject: teachers[i].gradeOrSubject,
                                        note: teachers[i].note
                                    }
                                })
                            );

                            //we save particular teacher dates in CertificatedSubRequestSpecificTeacherDates
                            let dateArray = teachers[i].datesNeeded;
                            if (CertificatedSubRequestTeacherDataResponse) {
                                for (let j = 0; j < dateArray.length; j++) {
                                    await API.graphql(
                                        graphqlOperation(mutations.createCertificatedSubRequestSpecificTeacherDates, {
                                            input: {
                                                teacherId: CertificatedSubRequestTeacherDataResponse.data.createCertificatedSubRequestTeacherData.id,
                                                date: moment(dateArray[j]).format("YYYY-MM-DD")
                                            }
                                        })
                                    );

                                }
                            }

                        }

                        //we call this funding account details count time.
                        for (let k = 0; k < fundingAccounts.length; k++) {
                            //save details in CertificatedSubRequestFundingAccountDetails table
                        
                            await API.graphql(
                                graphqlOperation(mutations.createCertificatedSubRequestFundingAccountDetails, {
                                    input: {
                                        reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                                        fundingAccountTypeId: fundingAccounts[k].fundingAccount?.code,
                                        accountNumber: fundingAccounts[k].programAccountNumber,
                                        remarks: fundingAccounts[k]?.remarks,
                                        percentage: fundingAccounts[k]?.percentageValue,
                                        noteIfSpecify: ''
                                    }
                                })
                            );
                        }

                        //after we add entry in CertificatedSubRequestTransactionCycle table
                        await API.graphql(
                            graphqlOperation(mutations.createCertificatedSubRequestTransactionCycle, {
                                input: {
                                    reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                                    from_Employee_Id: globalLoggedUserId,
                                    to_Employee_Id: selectedFirstApprover ? selectedFirstApprover?.code : CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.firstApproverId,
                                    status: 'OPEN',
                                    isApproved: false
                                }
                            })
                        );

                        await handleNotificationsOnStatusChangeforSubstituteRequestCertificated('OPEN', CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id, "SUBSTITUTE_REQUEST_CERTIFICATED", selectedFirstApprover ? selectedFirstApprover?.code : CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.firstApproverId, loggedUserId);

                        setPleaseWaitButton(false);
                        toast.success('The form has been cloned.');

                        navigateTo("/substitute_request_certificated");
                        // if (previousRoute?.[0]) {
                        //     navigateTo(previousRoute?.[0]);
                        // }else{
                        // navigateTo("/substitute_request_certificated");
                        // }

                    }

                } catch (error) {
                    console.log('Error saving CertificatedSubInitiateRequestResponse', error);
                }
            }else{

            if (reportId) {
              
                try {
                    // const originalCertificatedSubInitiateRequest = await DataStore.query(CertificatedSubInitiateRequest, reportId);
                    const originalCertificatedSubInitiateRequest = await graphQLFindRecordById("getCertificatedSubInitiateRequest", reportId)

                    // const updatedPost = await DataStore.save(
                    //     CertificatedSubInitiateRequest.copyOf(originalCertificatedSubInitiateRequest, updated => {
                    //         updated.schoolOrDeptId = selectedSchool?.code;
                    //         updated.reportDate = moment(initiateNewReportDate).format("YYYY-MM-DD");
                    //         updated.purposeOfReport = specifyPurposeValue;
                    //         updated.status = "SUBMITTED";
                    //         updated.assighmentTitle = assighmentTitle;
                    //         updated.submittedBy = globalLoggedUserId;
                    //         updated.submittedOn = moment().format("YYYY-MM-DD");
                    //         updated.firstApproverId = selectedFirstApprover?.code;
                    //         updated.secondApproverId = selectedSecondApprover?.code;
                    //         updated.payrollId = selectedPayroll?.code;
                    //     })
                    // );

                    const updatedPost = await API.graphql({
                        query: mutations.updateCertificatedSubInitiateRequest,
                        variables: {
                            input: {
                                id: originalCertificatedSubInitiateRequest.id,
                                _version: originalCertificatedSubInitiateRequest._version,
                                schoolOrDeptId: selectedSchool?.code,
                                reportDate: moment(initiateNewReportDate).format("YYYY-MM-DD"),
                                purposeOfReport: specifyPurposeValue,
                                status: "SUBMITTED",
                                assighmentTitle: assighmentTitle,
                                submittedBy: lastPart === "SuperAdminDashboard" ? originalCertificatedSubInitiateRequest.submittedBy :
                                globalLoggedUserId,
                                submittedOn: moment().format("YYYY-MM-DD"),
                                firstApproverId: selectedFirstApprover?.code,
                                secondApproverId: selectedSecondApprover === null ? null : selectedSecondApprover?.code,
                                thirdApproverId: selectedThirdApprover === null ? null : selectedThirdApprover?.code,
                                payrollId: selectedPayroll?.code
                            }
                        }
                    });

                    // const original = await DataStore.query(CertificatedSubRequestTransactionCycle
                    //     , (c) => c.reportId.eq(reportId), {
                    //     sort: (s) => s.createdAt(SortDirection.DESCENDING)
                    // }
                    // );

                    let original = await graphQLGetAllData("listCertificatedSubRequestTransactionCycles", [{ reportId: { eq: reportId } }])
                    original = original.sort((b, a) => b.createdAt.localeCompare(a.createdAt));  
                    console.log("originaloriginal",original);

                    const currentDateTime = moment().format("YYYY-MM-DD HH:mm:ss");
                    if(lastPart != 'SuperAdminDashboard'){
                        if(original.length>0){
                            const updatedPost = await API.graphql({
                                query: mutations.updateCertificatedSubRequestTransactionCycle,
                                variables: {
                                    input: {
                                        id: original[0].id,
                                        _version: original[0]._version,
                                        from_Employee_Id: globalLoggedUserId,
                                        to_Employee_Id: selectedFirstApprover ? selectedFirstApprover?.code : updatedPost.data.createCertificatedSubInitiateRequest.firstApproverId,
                                        customUpdatedAt: currentDateTime
                                    }
                                }
                            });
                        }else{   
                        await API.graphql(
                            graphqlOperation(mutations.createCertificatedSubRequestTransactionCycle, {
                                input: {
                                    reportId: updatedPost.data.updateCertificatedSubInitiateRequest.id,
                                    from_Employee_Id: globalLoggedUserId,
                                    to_Employee_Id: selectedFirstApprover ? selectedFirstApprover?.code : updatedPost.data.createCertificatedSubInitiateRequest.firstApproverId,
                                    status: 'OPEN',
                                    isApproved: false
                                }
                            })
                        );
                        }
                    }
                    else{
                        if(lastPart === 'SuperAdminDashboard' && isValueChange){
                            const updatedPost = await API.graphql({
                                query: mutations.updateCertificatedSubRequestTransactionCycle,
                                variables: {
                                    input: {
                                        id: original[0].id,
                                        _version: original[0]._version,
                                        from_Employee_Id: globalLoggedUserId,
                                        // to_Employee_Id: selectedFirstApprover ? selectedFirstApprover?.code : updatedPost.data.createCertificatedSubInitiateRequest.firstApproverId,
                                        customUpdatedAt: currentDateTime
                                    }
                                }
                            });
                        }
                    }

                    // await API.graphql(
                    //     graphqlOperation(mutations.createCertificatedSubRequestTransactionCycle, {
                    //         input: {
                    //             reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                    //             from_Employee_Id: globalLoggedUserId,
                    //             to_Employee_Id: selectedFirstApprover ? selectedFirstApprover?.code : CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.firstApproverId,
                    //             status: 'OPEN',
                    //             isApproved: false
                    //         }
                    //     })
                    // );
                    // await DataStore.save(
                    //     CertificatedSubRequestTransactionCycle.copyOf(original[0], updated => {
                    //         updated.reportId = updatedPost.data.updateCertificatedSubInitiateRequest.id;
                    //         updated.from_Employee_Id = globalLoggedUserId;
                    //         // to_Employee_Id: CertificatedSubInitiateRequestResponse.firstApproverId,
                    //         updated.to_Employee_Id = selectedFirstApprover?.code;
                    //         updated.status = 'OPEN';
                    //         updated.isApproved = false;
                    //     }
                    //     )
                    // );

                    //commenting for review resubmitt reject cae
                    // await API.graphql({
                    // query: mutations.updateCertificatedSubRequestTransactionCycle,
                    // variables: {
                    // input: {
                    // id: original[0].id,
                    // _version: original[0]._version,
                    // reportId: updatedPost.data.updateCertificatedSubInitiateRequest.id,
                    // from_Employee_Id: globalLoggedUserId,
                    ///////to_Employee_Id: CertificatedSubInitiateRequestResponse.firstApproverId,
                    // to_Employee_Id: selectedFirstApprover?.code,
                    // status: reportStatus === 'Rejected' ? 'REJECTED' : 'OPEN',
                    // isApproved: false
                    // }
                    // }
                    // });

                    await handleNotificationsOnStatusChangeforSubstituteRequestCertificated('OPEN', updatedPost.data.updateCertificatedSubInitiateRequest.id, "SUBSTITUTE_REQUEST_CERTIFICATED", selectedFirstApprover?.code, originalCertificatedSubInitiateRequest.submittedBy);

                    //after that we update data from CertificatedSubRequestTeacherData table with reprtId.
                    if (updatedPost) {

                        //first delete all teacher and funding account which report id is same.
                        // const toDeleteCertificatedSubRequestTeacherData = await DataStore.query(CertificatedSubRequestTeacherData, c => c.reportId.eq(updatedPost.id));

                        const toDeleteCertificatedSubRequestTeacherData = await graphQLGetAllData("listCertificatedSubRequestTeacherData", [{ reportId: { eq: updatedPost.data.updateCertificatedSubInitiateRequest.id } }])

                        // const toDeleteCertificatedSubRequestFundingAccountDetails = await DataStore.query(CertificatedSubRequestFundingAccountDetails, c => c.reportId.eq(updatedPost.data.updateCertificatedSubInitiateRequest.id));

                        const toDeleteCertificatedSubRequestFundingAccountDetails = await graphQLGetAllData("listCertificatedSubRequestFundingAccountDetails", [{ reportId: { eq: updatedPost.data.updateCertificatedSubInitiateRequest.id } }])

                        for (let delItem = 0; delItem < toDeleteCertificatedSubRequestTeacherData.length; delItem++) {
                            // DataStore.delete(toDeleteCertificatedSubRequestTeacherData[delItem]);
                            await API.graphql({
                                query: mutations.deleteCertificatedSubRequestTeacherData,
                                variables: {
                                    input: {
                                        id: toDeleteCertificatedSubRequestTeacherData[delItem].id,
                                        _version: toDeleteCertificatedSubRequestTeacherData[delItem]._version
                                    }
                                }
                            });

                            //after delete teacher data we delete particular teacher dates.
                            // const toDeleteCertificatedSubRequestSpecificTeacherDates = await DataStore.query(CertificatedSubRequestSpecificTeacherDates, c => c.teacherId.eq(toDeleteCertificatedSubRequestTeacherData[delItem].id));


                            const toDeleteCertificatedSubRequestSpecificTeacherDates = await graphQLGetAllData("listCertificatedSubRequestSpecificTeacherDates", [{ teacherId: { eq: toDeleteCertificatedSubRequestTeacherData[delItem].id } }])

                            for (let delDates = 0; delDates < toDeleteCertificatedSubRequestSpecificTeacherDates.length; delDates++) {
                                // DataStore.delete(toDeleteCertificatedSubRequestSpecificTeacherDates[delDates]);
                                await API.graphql({
                                    query: mutations.deleteCertificatedSubRequestSpecificTeacherDates,
                                    variables: {
                                        input: {
                                            id: toDeleteCertificatedSubRequestSpecificTeacherDates[delDates].id,
                                            _version: toDeleteCertificatedSubRequestSpecificTeacherDates[delDates]._version
                                        }
                                    }
                                });
                            }
                        }

                        for (let delFundItem = 0; delFundItem < toDeleteCertificatedSubRequestFundingAccountDetails.length; delFundItem++) {
                            // DataStore.delete(toDeleteCertificatedSubRequestFundingAccountDetails[delFundItem]);
                            await API.graphql({
                                query: mutations.deleteCertificatedSubRequestFundingAccountDetails,
                                variables: {
                                    input: {
                                        id: toDeleteCertificatedSubRequestFundingAccountDetails[delFundItem].id,
                                        _version: toDeleteCertificatedSubRequestFundingAccountDetails[delFundItem]._version
                                    }
                                }
                            });
                        }

                        //after delete teacher data add new teacher data with same report Id.
                        //we call this code teachers count time.
                        for (let i = 0; i < teachers.length; i++) {
                            // const CertificatedSubRequestTeacherDataResponse = await DataStore.save(new CertificatedSubRequestTeacherData(
                            //     {
                            //         reportId: updatedPost.data.updateCertificatedSubInitiateRequest.id,
                            //         teacherId: teachers[i].teacherName?.code,
                            //         indicateIf: teachers[i].indicateIf?.name,
                            //         gradeOrSubject: teachers[i].gradeOrSubject,
                            //         note: teachers[i].note
                            //     }
                            // ));

                            const CertificatedSubRequestTeacherDataResponse = await API.graphql(
                                graphqlOperation(mutations.createCertificatedSubRequestTeacherData, {
                                    input: {
                                        reportId: updatedPost.data.updateCertificatedSubInitiateRequest.id,
                                        teacherId: teachers[i].teacherName?.code,
                                        indicateIf: teachers[i].indicateIf?.name,
                                        gradeOrSubject: teachers[i].gradeOrSubject,
                                        note: teachers[i].note
                                    }
                                })
                            );



                            //we save particular teacher dates in CertificatedSubRequestSpecificTeacherDates
                            let dateArray = teachers[i].datesNeeded;
                            if (CertificatedSubRequestTeacherDataResponse) {
                                for (let j = 0; j < dateArray.length; j++) {

                                    // await DataStore.save(new CertificatedSubRequestSpecificTeacherDates(
                                    //     {
                                    //         teacherId: CertificatedSubRequestTeacherDataResponse.data.createCertificatedSubRequestTeacherData.id,
                                    //         date: moment(dateArray[j]).format("YYYY-MM-DD")
                                    //     }
                                    // ));

                                    await API.graphql(
                                        graphqlOperation(mutations.createCertificatedSubRequestSpecificTeacherDates, {
                                            input: {
                                                teacherId: CertificatedSubRequestTeacherDataResponse.data.createCertificatedSubRequestTeacherData.id,
                                                date: moment(dateArray[j]).format("YYYY-MM-DD")
                                            }
                                        })
                                    );

                                }
                            }

                        }

                        //we call this funding account details count time.
                        for (let k = 0; k < fundingAccounts.length; k++) {
                            //save details in CertificatedSubRequestFundingAccountDetails table
                            // await DataStore.save(new CertificatedSubRequestFundingAccountDetails(
                            //     {
                            //         reportId: updatedPost.data.updateCertificatedSubInitiateRequest.id,
                            //         fundingAccountTypeId: fundingAccounts[k].fundingAccount?.code,
                            //         accountNumber: fundingAccounts[k].programAccountNumber,
                            //         remarks: fundingAccounts[k]?.remarks,
                            //         noteIfSpecify: '',
                            //         percentage: fundingAccounts[k]?.percentageValue,
                            //     }
                            // ));

                            await API.graphql(
                                graphqlOperation(mutations.createCertificatedSubRequestFundingAccountDetails, {
                                    input: {
                                        reportId: updatedPost.data.updateCertificatedSubInitiateRequest.id,
                                        fundingAccountTypeId: fundingAccounts[k].fundingAccount?.code,
                                        accountNumber: fundingAccounts[k].programAccountNumber,
                                        remarks: fundingAccounts[k]?.remarks,
                                        noteIfSpecify: '',
                                        percentage: fundingAccounts[k]?.percentageValue,
                                    }
                                })
                            );

                        }


                        if (reportStatus === SUB_CERTIFICATED_STATUS.PENDING) { //'Pending'
                            await API.graphql(
                                graphqlOperation(mutations.createCertificatedSubRequestTransactionCycle, {
                                    input: {
                                        reportId: updatedPost.data.updateCertificatedSubInitiateRequest.id,
                                        from_Employee_Id: globalLoggedUserId,
                                        to_Employee_Id: updatedPost.data.updateCertificatedSubInitiateRequest.firstApproverId,
                                        status: 'OPEN',
                                        isApproved: false
                                    }
                                })
                            );

                            await handleNotificationsOnStatusChangeforSubstituteRequestCertificated('OPEN', updatedPost.data.updateCertificatedSubInitiateRequest.id, "SUBSTITUTE_REQUEST_CERTIFICATED", updatedPost.data.updateCertificatedSubInitiateRequest.firstApproverId, loggedUserId);


                        }

                        if (reportStatus == SUB_CERTIFICATED_STATUS.REJECTED) { //'Rejected'
                            //for reviewed and resubmit add new entry in CertificatedSubRequestTransactionCycle  table.
                            // const post = await DataStore.save(
                            //     new CertificatedSubRequestTransactionCycle({
                            //         reportId: updatedPost.data.updateCertificatedSubInitiateRequest.id,
                            //         from_Employee_Id: globalLoggedUserId,
                            //         to_Employee_Id: updatedPost.data.updateCertificatedSubInitiateRequest.firstApproverId,
                            //         status: 'Reviewed & resubmitted',
                            //         isApproved: false
                            //     })
                            // );

                            await API.graphql(
                                graphqlOperation(mutations.createCertificatedSubRequestTransactionCycle, {
                                    input: {
                                        reportId: updatedPost.data.updateCertificatedSubInitiateRequest.id,
                                        from_Employee_Id: globalLoggedUserId,
                                        to_Employee_Id: updatedPost.data.updateCertificatedSubInitiateRequest.firstApproverId,
                                        status: 'Reviewed & resubmitted',
                                        isApproved: false
                                    }
                                })
                            );

                            await handleNotificationsOnStatusChangeforSubstituteRequestCertificated('REVIEWED&RESUBMITTED', updatedPost.data.updateCertificatedSubInitiateRequest.id, "SUBSTITUTE_REQUEST_CERTIFICATED", updatedPost.data.updateCertificatedSubInitiateRequest.firstApproverId, originalCertificatedSubInitiateRequest.submittedBy);
                        } else{
                           
                            const original = await graphQLGetAllData("listCertificatedSubRequestTransactionCycles", [{ reportId: { eq: reportId } }])

                                let NewRecord = original.sort((b, a) => a.createdAt.localeCompare(b.createdAt));
                                     // return a.propertyName - b.propertyName;

                                

                                
                            if(lastPart === "SuperAdminDashboard"){
                                    let updatedPost1 = updatedPost.data.updateCertificatedSubInitiateRequest;
                                    
                                    let principalSiteAdmin = originalCertificatedSubInitiateRequest.firstApproverId;
                                    let budgetClerk = originalCertificatedSubInitiateRequest?.secondApproverId;
                                    let budgetManager = originalCertificatedSubInitiateRequest?.thirdApproverId;
    
                                    if (NewRecord.length > 0) {
                                        let toEmployeeId = "";
                                        let toEmpId = NewRecord[0].to_Employee_Id;
                                        switch (toEmpId) {
                                            case principalSiteAdmin:
                                                toEmployeeId =  updatedPost1?.firstApproverId;
                                                break;
    
                                            case budgetClerk:
                                                toEmployeeId =  updatedPost1?.secondApproverId;
                                                break;
    
                                            case budgetManager:
                                                toEmployeeId =  updatedPost1?.thirdApproverId;
                                                break;
    
                                            default:
                                                toEmployeeId = ""
                                        }
                                        if (toEmployeeId != "") {
                                           let UpdatedRecordData = await API.graphql(
                                                graphqlOperation(mutations.updateCertificatedSubRequestTransactionCycle,{
                                                    input: {
                                                        id: NewRecord[0].id,
                                                        _version: NewRecord[0]._version,
                                                        to_Employee_Id: toEmployeeId,
                                                        status: reportStatus,
                                                        isApproved: false,
                                                        remark: "",
                                                        // updatedAt: moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
                                                    }
                                                })
                                            );

                                            console.log('UpdatedRecordData',UpdatedRecordData);
    
                                        }
                                    } 
                            }
                            
                            }

                        setPleaseWaitButton(false);
                        toast.success('Data Updated Successfully.');

                        // if (certificatedSubReqIsSuperadmin) {
                        //     navigateTo('/substitute_request_certificated/SuperAdminDashboard');
                        // }else{
                        //     navigateTo("/substitute_request_certificated");
                        // }
                        if (previousRoute?.[0]) {
                            navigateTo(previousRoute?.[0]);
                        }else{
                        navigateTo("/substitute_request_certificated");
                        }
                    }

                } catch (error) {
                    console.log('Error Updating CertificatedSubInitiateRequestResponse', error);
                }
            } else {
                //aws amplify data submit in database code start.
                try {
                    // const CertificatedSubInitiateRequestResponse = await DataStore.save(new CertificatedSubInitiateRequest(
                    //     {
                    //         schoolOrDeptId: selectedSchool?.code,
                    //         reportDate: moment(initiateNewReportDate).format("YYYY-MM-DD"),
                    //         purposeOfReport: specifyPurposeValue,
                    //         assighmentTitle: assighmentTitle,
                    //         status: "SUBMITTED",
                    //         submittedBy: globalLoggedUserId,
                    //         submittedOn: moment().format("YYYY-MM-DD"),
                    //         firstApproverId: selectedFirstApprover?.code,
                    //         secondApproverId: selectedSecondApprover?.code,
                    //         thirdApproverId: selectedThirdApprover?.code,
                    //         payrollId: selectedPayroll?.code
                    //     }
                    // ));


                    const CertificatedSubInitiateRequestResponse = await API.graphql(
                        graphqlOperation(mutations.createCertificatedSubInitiateRequest, {
                            input: {
                                schoolOrDeptId: selectedSchool?.code,
                                reportDate: moment(initiateNewReportDate).format("YYYY-MM-DD"),
                                purposeOfReport: specifyPurposeValue,
                                assighmentTitle: assighmentTitle,
                                status: "SUBMITTED",
                                submittedBy: globalLoggedUserId,
                                submittedOn: moment().format("YYYY-MM-DD"),
                                firstApproverId: selectedFirstApprover?.code,
                                secondApproverId: selectedSecondApprover === null ? null : selectedSecondApprover?.code,
                                thirdApproverId: selectedThirdApprover === null ? null : selectedThirdApprover?.code,
                                payrollId: selectedPayroll?.code
                            }
                        })
                    );


                    //after that we save data into CertificatedSubRequestTeacherData table.
                    if (CertificatedSubInitiateRequestResponse) {

                        //we call this code teachers count time.
                        for (let i = 0; i < teachers.length; i++) {
                            // const CertificatedSubRequestTeacherDataResponse = await DataStore.save(new CertificatedSubRequestTeacherData(
                            //     {
                            //         reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                            //         teacherId: teachers[i].teacherName?.code,
                            //         indicateIf: teachers[i].indicateIf?.name,
                            //         gradeOrSubject: teachers[i].gradeOrSubject,
                            //         note: teachers[i].note
                            //     }
                            // ));

                            const CertificatedSubRequestTeacherDataResponse = await API.graphql(
                                graphqlOperation(mutations.createCertificatedSubRequestTeacherData, {
                                    input: {
                                        reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                                        teacherId: teachers[i].teacherName?.code,
                                        indicateIf: teachers[i].indicateIf?.name,
                                        gradeOrSubject: teachers[i].gradeOrSubject,
                                        note: teachers[i].note
                                    }
                                })
                            );


                            //we save particular teacher dates in CertificatedSubRequestSpecificTeacherDates
                            let dateArray = teachers[i].datesNeeded;
                            if (CertificatedSubRequestTeacherDataResponse) {
                                for (let j = 0; j < dateArray.length; j++) {

                                    // await DataStore.save(new CertificatedSubRequestSpecificTeacherDates(
                                    //     {
                                    //         teacherId: CertificatedSubRequestTeacherDataResponse.data.createCertificatedSubRequestTeacherData.id,
                                    //         date: moment(dateArray[j]).format("YYYY-MM-DD")
                                    //     }
                                    // ));

                                    await API.graphql(
                                        graphqlOperation(mutations.createCertificatedSubRequestSpecificTeacherDates, {
                                            input: {
                                                teacherId: CertificatedSubRequestTeacherDataResponse.data.createCertificatedSubRequestTeacherData.id,
                                                date: moment(dateArray[j]).format("YYYY-MM-DD")
                                            }
                                        })
                                    );

                                }
                            }

                        }

                        //we call this funding account details count time.
                        for (let k = 0; k < fundingAccounts.length; k++) {
                            //save details in CertificatedSubRequestFundingAccountDetails table
                            // await DataStore.save(new CertificatedSubRequestFundingAccountDetails(
                            //     {
                            //         reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                            //         fundingAccountTypeId: fundingAccounts[k].fundingAccount?.code,
                            //         accountNumber: fundingAccounts[k].programAccountNumber,
                            //         remarks: fundingAccounts[k]?.remarks,
                            //         percentage: fundingAccounts[k]?.percentageValue,
                            //         noteIfSpecify: ''
                            //     }
                            // ));

                            await API.graphql(
                                graphqlOperation(mutations.createCertificatedSubRequestFundingAccountDetails, {
                                    input: {
                                        reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                                        fundingAccountTypeId: fundingAccounts[k].fundingAccount?.code,
                                        accountNumber: fundingAccounts[k].programAccountNumber,
                                        remarks: fundingAccounts[k]?.remarks,
                                        percentage: fundingAccounts[k]?.percentageValue,
                                        noteIfSpecify: ''
                                    }
                                })
                            );

                        }

                        //after we add entry in CertificatedSubRequestTransactionCycle table
                        // await DataStore.save(new CertificatedSubRequestTransactionCycle(
                        //     {
                        //         reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                        //         from_Employee_Id: globalLoggedUserId,
                        //         // to_Employee_Id: CertificatedSubInitiateRequestResponse.firstApproverId,
                        //         to_Employee_Id: selectedFirstApprover ? selectedFirstApprover?.code : CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.firstApproverId,
                        //         status: 'OPEN',
                        //         isApproved: false
                        //     }
                        // ));

                        await API.graphql(
                            graphqlOperation(mutations.createCertificatedSubRequestTransactionCycle, {
                                input: {
                                    reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                                    from_Employee_Id: globalLoggedUserId,
                                    to_Employee_Id: selectedFirstApprover ? selectedFirstApprover?.code : CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.firstApproverId,
                                    status: 'OPEN',
                                    isApproved: false
                                }
                            })
                        );


                        await handleNotificationsOnStatusChangeforSubstituteRequestCertificated('OPEN', CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id, "SUBSTITUTE_REQUEST_CERTIFICATED", selectedFirstApprover ? selectedFirstApprover?.code : CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.firstApproverId, loggedUserId);


                        setPleaseWaitButton(false);
                        toast.success('Data Added Successfully.');

                        // if (certificatedSubReqIsSuperadmin) {
                        //     navigateTo('/substitute_request_certificated/SuperAdminDashboard');
                        // }else{
                        //     navigateTo("/substitute_request_certificated");
                        // }
                        if (previousRoute?.[0]) {
                            navigateTo(previousRoute?.[0]);
                        }else{
                        navigateTo("/substitute_request_certificated");
                        }

                    }

                } catch (error) {
                    console.log('Error saving CertificatedSubInitiateRequestResponse', error);
                }
                //aws amplify data submit in database code end.
            }
        }

        } else if (status === "RESUBMITED") {
            //show only for submit button
            setPleaseWaitButton(true);
            if(reportStatus=="copyReport"){
                try {
                    const CertificatedSubInitiateRequestResponse = await API.graphql(
                        graphqlOperation(mutations.createCertificatedSubInitiateRequest, {
                            input: {
                                schoolOrDeptId: selectedSchool?.code,
                                reportDate: moment(initiateNewReportDate).format("YYYY-MM-DD"),
                                purposeOfReport: specifyPurposeValue,
                                assighmentTitle: assighmentTitle,
                                status: "SUBMITTED",
                                submittedBy: globalLoggedUserId,
                                submittedOn: moment().format("YYYY-MM-DD"),
                                firstApproverId: selectedFirstApprover?.code,
                                secondApproverId: selectedSecondApprover === null ? null : selectedSecondApprover?.code,
                                thirdApproverId: selectedThirdApprover === null ? null : selectedThirdApprover?.code,
                                payrollId: selectedPayroll?.code
                            }
                        })
                    );


                    //after that we save data into CertificatedSubRequestTeacherData table.
                    if (CertificatedSubInitiateRequestResponse) {

                        //we call this code teachers count time.
                        for (let i = 0; i < teachers.length; i++) {
                            
                            const CertificatedSubRequestTeacherDataResponse = await API.graphql(
                                graphqlOperation(mutations.createCertificatedSubRequestTeacherData, {
                                    input: {
                                        reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                                        teacherId: teachers[i].teacherName?.code,
                                        indicateIf: teachers[i].indicateIf?.name,
                                        gradeOrSubject: teachers[i].gradeOrSubject,
                                        note: teachers[i].note
                                    }
                                })
                            );


                            //we save particular teacher dates in CertificatedSubRequestSpecificTeacherDates
                            let dateArray = teachers[i].datesNeeded;
                            if (CertificatedSubRequestTeacherDataResponse) {
                                for (let j = 0; j < dateArray.length; j++) {

                                    await API.graphql(
                                        graphqlOperation(mutations.createCertificatedSubRequestSpecificTeacherDates, {
                                            input: {
                                                teacherId: CertificatedSubRequestTeacherDataResponse.data.createCertificatedSubRequestTeacherData.id,
                                                date: moment(dateArray[j]).format("YYYY-MM-DD")
                                            }
                                        })
                                    );

                                }
                            }

                        }

                        //we call this funding account details count time.
                        for (let k = 0; k < fundingAccounts.length; k++) {
                            //save details in CertificatedSubRequestFundingAccountDetails table
                           
                            await API.graphql(
                                graphqlOperation(mutations.createCertificatedSubRequestFundingAccountDetails, {
                                    input: {
                                        reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                                        fundingAccountTypeId: fundingAccounts[k].fundingAccount?.code,
                                        accountNumber: fundingAccounts[k].programAccountNumber,
                                        remarks: fundingAccounts[k]?.remarks,
                                        percentage: fundingAccounts[k]?.percentageValue,
                                        noteIfSpecify: ''
                                    }
                                })
                            );

                        }

                        //after we add entry in CertificatedSubRequestTransactionCycle table
                        await API.graphql(
                            graphqlOperation(mutations.createCertificatedSubRequestTransactionCycle, {
                                input: {
                                    reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                                    from_Employee_Id: globalLoggedUserId,
                                    to_Employee_Id: selectedFirstApprover ? selectedFirstApprover?.code : CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.firstApproverId,
                                    status: 'OPEN',
                                    isApproved: false
                                }
                            })
                        );

                        await handleNotificationsOnStatusChangeforSubstituteRequestCertificated('OPEN', CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id, "SUBSTITUTE_REQUEST_CERTIFICATED", selectedFirstApprover ? selectedFirstApprover?.code : CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.firstApproverId, loggedUserId);

                        setPleaseWaitButton(false);
                        toast.success('The form has been cloned.');
                        
                        if (previousRoute?.[0]) {
                            navigateTo(previousRoute?.[0]);
                        }else{
                        navigateTo("/substitute_request_certificated");
                        }
                    }

                } catch (error) {
                    console.log('Error saving CertificatedSubInitiateRequestResponse', error);
                }
            }else{
            if (reportId) {
                try {
                    // const originalCertificatedSubInitiateRequest = await DataStore.query(CertificatedSubInitiateRequest, reportId);
                    const originalCertificatedSubInitiateRequest = await graphQLFindRecordById("getCertificatedSubInitiateRequest", reportId)
                    console.log("🚀 ~ file: initiateNewReport.js:1200 ~ saveInitiateNewReportInfo ~ originalCertificatedSubInitiateRequest: 🎈🎈😁😁😁", originalCertificatedSubInitiateRequest)
                    if (originalCertificatedSubInitiateRequest.Status === "APPROVAL_REJECTED") {

                        const updatedPost = await API.graphql({
                            query: mutations.updateCertificatedSubInitiateRequest,
                            variables: {
                                input: {
                                    id: originalCertificatedSubInitiateRequest.id,
                                    _version: originalCertificatedSubInitiateRequest._version,
                                    schoolOrDeptId: selectedSchool?.code,
                                    reportDate: moment(initiateNewReportDate).format("YYYY-MM-DD"),
                                    purposeOfReport: specifyPurposeValue,
                                    status: "RESUBMITED" ,
                                    assighmentTitle: assighmentTitle,
                                    // submittedBy: globalLoggedUserId,
                                    submittedBy: originalCertificatedSubInitiateRequest?.submittedBy,
                                    submittedOn: moment().format("YYYY-MM-DD"),
                                    firstApproverId: selectedFirstApprover?.code,
                                    secondApproverId: selectedSecondApprover === null ? null : selectedSecondApprover?.code,
                                    thirdApproverId: selectedThirdApprover === null ? null : selectedThirdApprover?.code,
                                    payrollId: selectedPayroll?.code
                                }
                            }
                        });

                        const original = await graphQLGetAllData("listCertificatedSubRequestTransactionCycles", [{ reportId: { eq: reportId } }])

                       
                        // await API.graphql(
                        //     graphqlOperation(mutations.createCertificatedSubRequestTransactionCycle, {
                        //         input: {
                        //             reportId: updatedPost.data.updateCertificatedSubInitiateRequest.id,
                        //             from_Employee_Id: globalLoggedUserId,
                        //             to_Employee_Id: selectedFirstApprover ? selectedFirstApprover?.code : updatedPost.data.createCertificatedSubInitiateRequest.firstApproverId,
                        //             status: 'OPEN',
                        //             isApproved: false
                        //         }
                        //     })
                        // );
                    } else {
                        const updatedPost = await API.graphql({
                            query: mutations.updateCertificatedSubInitiateRequest,
                            variables: {
                                input: {
                                    id: originalCertificatedSubInitiateRequest.id,
                                    _version: originalCertificatedSubInitiateRequest._version,
                                    schoolOrDeptId: selectedSchool?.code,
                                    reportDate: moment(initiateNewReportDate).format("YYYY-MM-DD"),
                                    purposeOfReport: specifyPurposeValue,
                                    status: "RESUBMITED",
                                    assighmentTitle: assighmentTitle,
                                    // submittedBy: globalLoggedUserId,
                                    submittedBy: originalCertificatedSubInitiateRequest?.submittedBy,
                                    submittedOn: moment().format("YYYY-MM-DD"),
                                    firstApproverId: selectedFirstApprover?.code,
                                    secondApproverId: selectedSecondApprover === null ? null : selectedSecondApprover?.code,
                                    thirdApproverId: selectedThirdApprover === null ? null : selectedThirdApprover?.code,
                                    payrollId: selectedPayroll?.code
                                }
                            }
                        });
                    }

                    // const updatedPost = await DataStore.save(
                    //     CertificatedSubInitiateRequest.copyOf(originalCertificatedSubInitiateRequest, updated => {
                    //         updated.schoolOrDeptId = selectedSchool?.code;
                    //         updated.reportDate = moment(initiateNewReportDate).format("YYYY-MM-DD");
                    //         updated.purposeOfReport = specifyPurposeValue;
                    //         updated.status = "SUBMITTED";
                    //         updated.assighmentTitle = assighmentTitle;
                    //         updated.submittedBy = globalLoggedUserId;
                    //         updated.submittedOn = moment().format("YYYY-MM-DD");
                    //         updated.firstApproverId = selectedFirstApprover?.code;
                    //         updated.secondApproverId = selectedSecondApprover?.code;
                    //         updated.payrollId = selectedPayroll?.code;
                    //     })
                    // );

                    const updatedPost = await API.graphql({
                        query: mutations.updateCertificatedSubInitiateRequest,
                        variables: {
                            input: {
                                id: originalCertificatedSubInitiateRequest.id,
                                _version: originalCertificatedSubInitiateRequest._version,
                                schoolOrDeptId: selectedSchool?.code,
                                reportDate: moment(initiateNewReportDate).format("YYYY-MM-DD"),
                                purposeOfReport: specifyPurposeValue,
                                status: loggedUserId === originalCertificatedSubInitiateRequest.submittedBy ? "RESUBMITED" : "SUBMITTED",
                                assighmentTitle: assighmentTitle,
                                // submittedBy: globalLoggedUserId,
                                submittedBy: originalCertificatedSubInitiateRequest?.submittedBy,

                                submittedOn: moment().format("YYYY-MM-DD"),
                                firstApproverId: selectedFirstApprover?.code,
                                secondApproverId: selectedSecondApprover === null ? null : selectedSecondApprover?.code,
                                thirdApproverId: selectedThirdApprover === null ? null : selectedThirdApprover?.code,
                                payrollId: selectedPayroll?.code
                            }
                        }
                    });

                    console.log("updatedPost123",updatedPost);

                    // const original = await DataStore.query(CertificatedSubRequestTransactionCycle
                    //     , (c) => c.reportId.eq(reportId), {
                    //     sort: (s) => s.createdAt(SortDirection.DESCENDING)
                    // }
                    // );

                    // const original = await graphQLGetAllData("listCertificatedSubRequestTransactionCycles", [{ reportId: { eq: reportId } }])
                  
                        
                    
                        // await API.graphql(
                        //     graphqlOperation(mutations.createCertificatedSubRequestTransactionCycle, {
                        //         input: {
                        //             reportId: updatedPost.data.updateCertificatedSubInitiateRequest.id,
                        //             from_Employee_Id: globalLoggedUserId,
                        //             to_Employee_Id: selectedFirstApprover ? selectedFirstApprover?.code : updatedPost.data.createCertificatedSubInitiateRequest.firstApproverId,
                        //             status: 'OPEN',
                        //             isApproved: false
                        //         }
                        //     })
                        // );
                   
                  
                    // await API.graphql(
                    //     graphqlOperation(mutations.createCertificatedSubRequestTransactionCycle, {
                    //         input: {
                    //             reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                    //             from_Employee_Id: globalLoggedUserId,
                    //             to_Employee_Id: selectedFirstApprover ? selectedFirstApprover?.code : CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.firstApproverId,
                    //             status: 'OPEN',
                    //             isApproved: false
                    //         }
                    //     })
                    // );
                    // await DataStore.save(
                    //     CertificatedSubRequestTransactionCycle.copyOf(original[0], updated => {
                    //         updated.reportId = updatedPost.data.updateCertificatedSubInitiateRequest.id;
                    //         updated.from_Employee_Id = globalLoggedUserId;
                    //         // to_Employee_Id: CertificatedSubInitiateRequestResponse.firstApproverId,
                    //         updated.to_Employee_Id = selectedFirstApprover?.code;
                    //         updated.status = 'OPEN';
                    //         updated.isApproved = false;
                    //     }
                    //     )
                    // );

                    //commenting for review resubmitt reject cae
                    // await API.graphql({
                    // query: mutations.updateCertificatedSubRequestTransactionCycle,
                    // variables: {
                    // input: {
                    // id: original[0].id,
                    // _version: original[0]._version,
                    // reportId: updatedPost.data.updateCertificatedSubInitiateRequest.id,
                    // from_Employee_Id: globalLoggedUserId,
                    ///////to_Employee_Id: CertificatedSubInitiateRequestResponse.firstApproverId,
                    // to_Employee_Id: selectedFirstApprover?.code,
                    // status: reportStatus === 'Rejected' ? 'REJECTED' : 'OPEN',
                    // isApproved: false
                    // }
                    // }
                    // });

                    // await handleNotificationsOnStatusChangeforSubstituteRequestCertificated('OPEN', updatedPost.data.updateCertificatedSubInitiateRequest.id, "SUBSTITUTE_REQUEST_CERTIFICATED", selectedFirstApprover?.code, originalCertificatedSubInitiateRequest.submittedBy);

                    //after that we update data from CertificatedSubRequestTeacherData table with reprtId.
                    if (updatedPost) {
                        //first delete all teacher and funding account which report id is same.
                        // const toDeleteCertificatedSubRequestTeacherData = await DataStore.query(CertificatedSubRequestTeacherData, c => c.reportId.eq(updatedPost.id));

                        const toDeleteCertificatedSubRequestTeacherData = await graphQLGetAllData("listCertificatedSubRequestTeacherData", [{ reportId: { eq: updatedPost.data.updateCertificatedSubInitiateRequest.id } }])

                        // const toDeleteCertificatedSubRequestFundingAccountDetails = await DataStore.query(CertificatedSubRequestFundingAccountDetails, c => c.reportId.eq(updatedPost.data.updateCertificatedSubInitiateRequest.id));

                        const toDeleteCertificatedSubRequestFundingAccountDetails = await graphQLGetAllData("listCertificatedSubRequestFundingAccountDetails", [{ reportId: { eq: updatedPost.data.updateCertificatedSubInitiateRequest.id } }])

                        for (let delItem = 0; delItem < toDeleteCertificatedSubRequestTeacherData.length; delItem++) {
                            // DataStore.delete(toDeleteCertificatedSubRequestTeacherData[delItem]);
                            await API.graphql({
                                query: mutations.deleteCertificatedSubRequestTeacherData,
                                variables: {
                                    input: {
                                        id: toDeleteCertificatedSubRequestTeacherData[delItem].id,
                                        _version: toDeleteCertificatedSubRequestTeacherData[delItem]._version
                                    }
                                }
                            });

                            //after delete teacher data we delete particular teacher dates.
                            // const toDeleteCertificatedSubRequestSpecificTeacherDates = await DataStore.query(CertificatedSubRequestSpecificTeacherDates, c => c.teacherId.eq(toDeleteCertificatedSubRequestTeacherData[delItem].id));


                            const toDeleteCertificatedSubRequestSpecificTeacherDates = await graphQLGetAllData("listCertificatedSubRequestSpecificTeacherDates", [{ teacherId: { eq: toDeleteCertificatedSubRequestTeacherData[delItem].id } }])

                            for (let delDates = 0; delDates < toDeleteCertificatedSubRequestSpecificTeacherDates.length; delDates++) {
                                // DataStore.delete(toDeleteCertificatedSubRequestSpecificTeacherDates[delDates]);
                                await API.graphql({
                                    query: mutations.deleteCertificatedSubRequestSpecificTeacherDates,
                                    variables: {
                                        input: {
                                            id: toDeleteCertificatedSubRequestSpecificTeacherDates[delDates].id,
                                            _version: toDeleteCertificatedSubRequestSpecificTeacherDates[delDates]._version
                                        }
                                    }
                                });
                            }
                        }

                        for (let delFundItem = 0; delFundItem < toDeleteCertificatedSubRequestFundingAccountDetails.length; delFundItem++) {
                            // DataStore.delete(toDeleteCertificatedSubRequestFundingAccountDetails[delFundItem]);
                            await API.graphql({
                                query: mutations.deleteCertificatedSubRequestFundingAccountDetails,
                                variables: {
                                    input: {
                                        id: toDeleteCertificatedSubRequestFundingAccountDetails[delFundItem].id,
                                        _version: toDeleteCertificatedSubRequestFundingAccountDetails[delFundItem]._version
                                    }
                                }
                            });
                        }

                        //after delete teacher data add new teacher data with same report Id.
                        //we call this code teachers count time.
                        for (let i = 0; i < teachers.length; i++) {
                            // const CertificatedSubRequestTeacherDataResponse = await DataStore.save(new CertificatedSubRequestTeacherData(
                            //     {
                            //         reportId: updatedPost.data.updateCertificatedSubInitiateRequest.id,
                            //         teacherId: teachers[i].teacherName?.code,
                            //         indicateIf: teachers[i].indicateIf?.name,
                            //         gradeOrSubject: teachers[i].gradeOrSubject,
                            //         note: teachers[i].note
                            //     }
                            // ));

                            const CertificatedSubRequestTeacherDataResponse = await API.graphql(
                                graphqlOperation(mutations.createCertificatedSubRequestTeacherData, {
                                    input: {
                                        reportId: updatedPost.data.updateCertificatedSubInitiateRequest.id,
                                        teacherId: teachers[i].teacherName?.code,
                                        indicateIf: teachers[i].indicateIf?.name,
                                        gradeOrSubject: teachers[i].gradeOrSubject,
                                        note: teachers[i].note
                                    }
                                })
                            );



                            //we save particular teacher dates in CertificatedSubRequestSpecificTeacherDates
                            let dateArray = teachers[i].datesNeeded;
                            if (CertificatedSubRequestTeacherDataResponse) {
                                for (let j = 0; j < dateArray.length; j++) {

                                    // await DataStore.save(new CertificatedSubRequestSpecificTeacherDates(
                                    //     {
                                    //         teacherId: CertificatedSubRequestTeacherDataResponse.data.createCertificatedSubRequestTeacherData.id,
                                    //         date: moment(dateArray[j]).format("YYYY-MM-DD")
                                    //     }
                                    // ));

                                    await API.graphql(
                                        graphqlOperation(mutations.createCertificatedSubRequestSpecificTeacherDates, {
                                            input: {
                                                teacherId: CertificatedSubRequestTeacherDataResponse.data.createCertificatedSubRequestTeacherData.id,
                                                date: moment(dateArray[j]).format("YYYY-MM-DD")
                                            }
                                        })
                                    );

                                }
                            }

                        }

                        //we call this funding account details count time.
                        for (let k = 0; k < fundingAccounts.length; k++) {
                            //save details in CertificatedSubRequestFundingAccountDetails table
                            // await DataStore.save(new CertificatedSubRequestFundingAccountDetails(
                            //     {
                            //         reportId: updatedPost.data.updateCertificatedSubInitiateRequest.id,
                            //         fundingAccountTypeId: fundingAccounts[k].fundingAccount?.code,
                            //         accountNumber: fundingAccounts[k].programAccountNumber,
                            //         remarks: fundingAccounts[k]?.remarks,
                            //         noteIfSpecify: '',
                            //         percentage: fundingAccounts[k]?.percentageValue,
                            //     }
                            // ));

                            await API.graphql(
                                graphqlOperation(mutations.createCertificatedSubRequestFundingAccountDetails, {
                                    input: {
                                        reportId: updatedPost.data.updateCertificatedSubInitiateRequest.id,
                                        fundingAccountTypeId: fundingAccounts[k].fundingAccount?.code,
                                        accountNumber: fundingAccounts[k].programAccountNumber,
                                        remarks: fundingAccounts[k]?.remarks,
                                        noteIfSpecify: '',
                                        percentage: fundingAccounts[k]?.percentageValue,
                                    }
                                })
                            );

                        }

                       
                        if (reportStatus === SUB_CERTIFICATED_STATUS.PENDING) { //'Pending'
                            await API.graphql(
                                graphqlOperation(mutations.createCertificatedSubRequestTransactionCycle, {
                                    input: {
                                        reportId: updatedPost.data.updateCertificatedSubInitiateRequest.id,
                                        from_Employee_Id: globalLoggedUserId,
                                        to_Employee_Id: updatedPost.data.updateCertificatedSubInitiateRequest.firstApproverId,
                                        status: 'OPEN',
                                        isApproved: false
                                    }
                                })
                            );

                            await handleNotificationsOnStatusChangeforSubstituteRequestCertificated('OPEN', updatedPost.data.updateCertificatedSubInitiateRequest.id, "SUBSTITUTE_REQUEST_CERTIFICATED", updatedPost.data.updateCertificatedSubInitiateRequest.firstApproverId, loggedUserId);


                        }

                      
                       
                        if (reportStatus == SUB_CERTIFICATED_STATUS.REJECTED) {  //'Rejected'
                            //for reviewed and resubmit add new entry in CertificatedSubRequestTransactionCycle  table.
                            // const post = await DataStore.save(
                            //     new CertificatedSubRequestTransactionCycle({
                            //         reportId: updatedPost.data.updateCertificatedSubInitiateRequest.id,
                            //         from_Employee_Id: globalLoggedUserId,
                            //         to_Employee_Id: updatedPost.data.updateCertificatedSubInitiateRequest.firstApproverId,
                            //         status: 'Reviewed & resubmitted',
                            //         isApproved: false
                            //     })
                            // );
                        
                            let original = await graphQLGetAllData("listCertificatedSubRequestTransactionCycles", [{ reportId: { eq: updatedPost.data.updateCertificatedSubInitiateRequest.id } }])
                                original = original.sort((b, a) => a.createdAt.localeCompare(b.createdAt));
                           
                           
                            //#436  & #438
                            let to_Employee_Id;
                           
                            if(original[0].to_Employee_Id === updatedPost.data.updateCertificatedSubInitiateRequest?.submittedBy){
                                to_Employee_Id = updatedPost.data.updateCertificatedSubInitiateRequest?.firstApproverId
                            }
                            else{
                                if (globalLoggedUserId == updatedPost.data.updateCertificatedSubInitiateRequest?.firstApproverId) {

                                    if (updatedPost.data.updateCertificatedSubInitiateRequest.secondApproverId) {
                                        to_Employee_Id = updatedPost.data.updateCertificatedSubInitiateRequest.secondApproverId;
                                    } else {
                                        to_Employee_Id = updatedPost.data.updateCertificatedSubInitiateRequest?.payrollId
                                    }
    
                                } else if (globalLoggedUserId == updatedPost.data.updateCertificatedSubInitiateRequest?.secondApproverId) {
                                    to_Employee_Id = updatedPost.data.updateCertificatedSubInitiateRequest?.thirdApproverId
                                } else if (globalLoggedUserId == updatedPost.data.updateCertificatedSubInitiateRequest?.thirdApproverId) {
                                    to_Employee_Id = updatedPost.data.updateCertificatedSubInitiateRequest?.payrollId
                                } else {
                                    to_Employee_Id = updatedPost.data.updateCertificatedSubInitiateRequest?.firstApproverId
                                }
                            }
                             



                            //---------
                            //update current transaction cycle entry start.
                                
                                if(original[0].to_Employee_Id===updatedPost.data.updateCertificatedSubInitiateRequest?.submittedBy){
                                const updatedCurrentTransactionCyclePost = await API.graphql({
                                    query: mutations.updateCertificatedSubRequestTransactionCycle,
                                    variables: {
                                        input: {
                                            id: original[0].id,
                                            _version: original[0]._version,
                                            status: 'Reviewed & resubmitted',
                                            to_Employee_Id: globalLoggedUserId,
                                            isApproved: true
                                        }
                                    }
                                });
                                console.log("updatedCurrentTransactionCyclePostupdatedCurrentTransactionCyclePost:-", updatedCurrentTransactionCyclePost);

                           
                            //update current transaction cycle entry end.
                            //---------

                            await API.graphql(
                                graphqlOperation(mutations.createCertificatedSubRequestTransactionCycle, {
                                    input: {
                                        reportId: updatedPost.data.updateCertificatedSubInitiateRequest.id,
                                        from_Employee_Id: globalLoggedUserId,
                                        // to_Employee_Id: updatedPost.data.updateCertificatedSubInitiateRequest.firstApproverId,
                                        to_Employee_Id: to_Employee_Id,
                                        // status: 'Reviewed & resubmitted',
                                        status: 'OPEN',
                                        isApproved: false
                                    }
                                })
                            );

                            await handleNotificationsOnStatusChangeforSubstituteRequestCertificated('REVIEWED&RESUBMITTED', updatedPost.data.updateCertificatedSubInitiateRequest.id, "SUBSTITUTE_REQUEST_CERTIFICATED", updatedPost.data.updateCertificatedSubInitiateRequest.firstApproverId, originalCertificatedSubInitiateRequest.submittedBy);
                                 
                        }
                        else{
                            
                            const original = await graphQLGetAllData("listCertificatedSubRequestTransactionCycles", [{ reportId: { eq: reportId } }])

                                let NewRecord = original.sort((b, a) => a.createdAt.localeCompare(b.createdAt));
                                     // return a.propertyName - b.propertyName;

                                

                                
                            if(lastPart === "SuperAdminDashboard"){
                                    let updatedPost1 = updatedPost.data.updateCertificatedSubInitiateRequest;
                                    
                                    let principalSiteAdmin = originalCertificatedSubInitiateRequest.firstApproverId;
                                    let budgetClerk = originalCertificatedSubInitiateRequest?.secondApproverId;
                                    let budgetManager = originalCertificatedSubInitiateRequest?.thirdApproverId;
    
                                    if (NewRecord.length > 0) {
                                        let toEmployeeId = "";
                                        let toEmpId = NewRecord[0].to_Employee_Id;
                                        switch (toEmpId) {
                                            case principalSiteAdmin:
                                                toEmployeeId =  updatedPost1?.firstApproverId;
                                                break;
    
                                            case budgetClerk:
                                                toEmployeeId =  updatedPost1?.secondApproverId;
                                                break;
    
                                            case budgetManager:
                                                toEmployeeId =  updatedPost1?.thirdApproverId;
                                                break;
    
                                            default:
                                                toEmployeeId = ""
                                        }
                                        if (toEmployeeId != "") {
                                           let UpdatedRecordData = await API.graphql(
                                                graphqlOperation(mutations.updateCertificatedSubRequestTransactionCycle,{
                                                    input: {
                                                        id: NewRecord[0].id,
                                                        _version: NewRecord[0]._version,
                                                        to_Employee_Id: toEmployeeId,
                                                        // status: reportStatus,
                                                        isApproved: false,
                                                        remark: "",
                                                        // updatedAt: moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
                                                    }
                                                })
                                            );

                                            console.log('UpdatedRecordData',UpdatedRecordData);
    
                                        }
                                    } 
                            }
                            
                        }
                        }
                       
                  

                        //---------------------------------------------------------
                        if (reportStatus == "EditByAp") {  //'Rejected'
                           
                            // let to_Employee_Id;
                            // if (globalLoggedUserId == updatedPost.data.updateCertificatedSubInitiateRequest?.firstApproverId) {

                            //     if (updatedPost.data.updateCertificatedSubInitiateRequest.secondApproverId) {
                            //         to_Employee_Id = updatedPost.data.updateCertificatedSubInitiateRequest.secondApproverId;
                            //     } else {
                            //         to_Employee_Id = updatedPost.data.updateCertificatedSubInitiateRequest?.payrollId
                            //     }

                            // } else if (globalLoggedUserId == updatedPost.data.updateCertificatedSubInitiateRequest?.secondApproverId) {
                            //     to_Employee_Id = updatedPost.data.updateCertificatedSubInitiateRequest?.thirdApproverId
                            // } else if (globalLoggedUserId == updatedPost.data.updateCertificatedSubInitiateRequest?.thirdApproverId) {
                            //     to_Employee_Id = updatedPost.data.updateCertificatedSubInitiateRequest?.payrollId
                            // } else {
                            //     to_Employee_Id = updatedPost.data.updateCertificatedSubInitiateRequest?.firstApproverId
                            // }

                            //---------
                            //update current transaction cycle entry start.
                            // let original = await graphQLGetAllData("listCertificatedSubRequestTransactionCycles", [{ reportId: { eq: updatedPost.data.updateCertificatedSubInitiateRequest.id } }])
                            // original = original.sort((b, a) => a.createdAt.localeCompare(b.createdAt));
                            // const updatedCurrentTransactionCyclePost = await API.graphql({
                            //     query: mutations.updateCertificatedSubRequestTransactionCycle,
                            //     variables: {
                            //         input: {
                            //             id: original[0].id,
                            //             _version: original[0]._version,
                            //             status: 'Reviewed & resubmitted',
                            //             isApproved: true
                            //         }
                            //     }
                            // });
                            // console.log("updatedCurrentTransactionCyclePostupdatedCurrentTransactionCyclePost:-", updatedCurrentTransactionCyclePost);
                            //update current transaction cycle entry end.
                            //---------

                            // await API.graphql(
                            //     graphqlOperation(mutations.createCertificatedSubRequestTransactionCycle, {
                            //         input: {
                            //             reportId: updatedPost.data.updateCertificatedSubInitiateRequest.id,
                            //             from_Employee_Id: original[0].from_Employee_Id,
                            //             to_Employee_Id: loggedUserId,
                            //             status: 'OPEN',
                            //             isApproved: false
                            //         }
                            //     })
                            // );

                            // await handleNotificationsOnStatusChangeforSubstituteRequestCertificated('REVIEWED&RESUBMITTED', updatedPost.data.updateCertificatedSubInitiateRequest.id, "SUBSTITUTE_REQUEST_CERTIFICATED", updatedPost.data.updateCertificatedSubInitiateRequest.firstApproverId, originalCertificatedSubInitiateRequest.submittedBy);
                        }
                        //---------------------------------------------------------

                        setPleaseWaitButton(false);
                        toast.success('Data Updated Successfully.');

                        // if (certificatedSubReqIsSuperadmin) {
                        //     navigateTo('/substitute_request_certificated/SuperAdminDashboard');
                        // }else{
                        //     navigateTo("/substitute_request_certificated/"+reportId);
                        // }
                        // console.log('previousRoute :>> ', previousRoute);
                        if (previousRoute?.[0]) {
                            navigateTo(previousRoute?.[0]);
                        }else{
                        // navigateTo("/substitute_request_certificated/"+reportId);
                        navigateTo("/substitute_request_certificated/");
                        }
                    }

                } catch (error) {
                    console.log('Error Updating CertificatedSubInitiateRequestResponse', error);
                }
            } else {
                //aws amplify data submit in database code start.
                try {
                    // const CertificatedSubInitiateRequestResponse = await DataStore.save(new CertificatedSubInitiateRequest(
                    //     {
                    //         schoolOrDeptId: selectedSchool?.code,
                    //         reportDate: moment(initiateNewReportDate).format("YYYY-MM-DD"),
                    //         purposeOfReport: specifyPurposeValue,
                    //         assighmentTitle: assighmentTitle,
                    //         status: "SUBMITTED",
                    //         submittedBy: globalLoggedUserId,
                    //         submittedOn: moment().format("YYYY-MM-DD"),
                    //         firstApproverId: selectedFirstApprover?.code,
                    //         secondApproverId: selectedSecondApprover?.code,
                    //         thirdApproverId: selectedThirdApprover?.code,
                    //         payrollId: selectedPayroll?.code
                    //     }
                    // ));


                    const CertificatedSubInitiateRequestResponse = await API.graphql(
                        graphqlOperation(mutations.createCertificatedSubInitiateRequest, {
                            input: {
                                schoolOrDeptId: selectedSchool?.code,
                                reportDate: moment(initiateNewReportDate).format("YYYY-MM-DD"),
                                purposeOfReport: specifyPurposeValue,
                                assighmentTitle: assighmentTitle,
                                status: "SUBMITTED",
                                submittedBy: globalLoggedUserId,
                                submittedOn: moment().format("YYYY-MM-DD"),
                                firstApproverId: selectedFirstApprover?.code,
                                secondApproverId: selectedSecondApprover === null ? null : selectedSecondApprover?.code,
                                thirdApproverId: selectedThirdApprover === null ? null : selectedThirdApprover?.code,
                                payrollId: selectedPayroll?.code
                            }
                        })
                    );


                    //after that we save data into CertificatedSubRequestTeacherData table.
                    if (CertificatedSubInitiateRequestResponse) {

                        //we call this code teachers count time.
                        for (let i = 0; i < teachers.length; i++) {
                            // const CertificatedSubRequestTeacherDataResponse = await DataStore.save(new CertificatedSubRequestTeacherData(
                            //     {
                            //         reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                            //         teacherId: teachers[i].teacherName?.code,
                            //         indicateIf: teachers[i].indicateIf?.name,
                            //         gradeOrSubject: teachers[i].gradeOrSubject,
                            //         note: teachers[i].note
                            //     }
                            // ));

                            const CertificatedSubRequestTeacherDataResponse = await API.graphql(
                                graphqlOperation(mutations.createCertificatedSubRequestTeacherData, {
                                    input: {
                                        reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                                        teacherId: teachers[i].teacherName?.code,
                                        indicateIf: teachers[i].indicateIf?.name,
                                        gradeOrSubject: teachers[i].gradeOrSubject,
                                        note: teachers[i].note
                                    }
                                })
                            );


                            //we save particular teacher dates in CertificatedSubRequestSpecificTeacherDates
                            let dateArray = teachers[i].datesNeeded;
                            if (CertificatedSubRequestTeacherDataResponse) {
                                for (let j = 0; j < dateArray.length; j++) {

                                    // await DataStore.save(new CertificatedSubRequestSpecificTeacherDates(
                                    //     {
                                    //         teacherId: CertificatedSubRequestTeacherDataResponse.data.createCertificatedSubRequestTeacherData.id,
                                    //         date: moment(dateArray[j]).format("YYYY-MM-DD")
                                    //     }
                                    // ));

                                    await API.graphql(
                                        graphqlOperation(mutations.createCertificatedSubRequestSpecificTeacherDates, {
                                            input: {
                                                teacherId: CertificatedSubRequestTeacherDataResponse.data.createCertificatedSubRequestTeacherData.id,
                                                date: moment(dateArray[j]).format("YYYY-MM-DD")
                                            }
                                        })
                                    );

                                }
                            }

                        }

                        //we call this funding account details count time.
                        for (let k = 0; k < fundingAccounts.length; k++) {
                            //save details in CertificatedSubRequestFundingAccountDetails table
                            // await DataStore.save(new CertificatedSubRequestFundingAccountDetails(
                            //     {
                            //         reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                            //         fundingAccountTypeId: fundingAccounts[k].fundingAccount?.code,
                            //         accountNumber: fundingAccounts[k].programAccountNumber,
                            //         remarks: fundingAccounts[k]?.remarks,
                            //         percentage: fundingAccounts[k]?.percentageValue,
                            //         noteIfSpecify: ''
                            //     }
                            // ));

                            await API.graphql(
                                graphqlOperation(mutations.createCertificatedSubRequestFundingAccountDetails, {
                                    input: {
                                        reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                                        fundingAccountTypeId: fundingAccounts[k].fundingAccount?.code,
                                        accountNumber: fundingAccounts[k].programAccountNumber,
                                        remarks: fundingAccounts[k]?.remarks,
                                        percentage: fundingAccounts[k]?.percentageValue,
                                        noteIfSpecify: ''
                                    }
                                })
                            );

                        }

                        //after we add entry in CertificatedSubRequestTransactionCycle table
                        // await DataStore.save(new CertificatedSubRequestTransactionCycle(
                        //     {
                        //         reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                        //         from_Employee_Id: globalLoggedUserId,
                        //         // to_Employee_Id: CertificatedSubInitiateRequestResponse.firstApproverId,
                        //         to_Employee_Id: selectedFirstApprover ? selectedFirstApprover?.code : CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.firstApproverId,
                        //         status: 'OPEN',
                        //         isApproved: false
                        //     }
                        // ));

                        await API.graphql(
                            graphqlOperation(mutations.createCertificatedSubRequestTransactionCycle, {
                                input: {
                                    reportId: CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id,
                                    from_Employee_Id: globalLoggedUserId,
                                    to_Employee_Id: selectedFirstApprover ? selectedFirstApprover?.code : CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.firstApproverId,
                                    status: 'OPEN',
                                    isApproved: false
                                }
                            })
                        );


                        await handleNotificationsOnStatusChangeforSubstituteRequestCertificated('OPEN', CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.id, "SUBSTITUTE_REQUEST_CERTIFICATED", selectedFirstApprover ? selectedFirstApprover?.code : CertificatedSubInitiateRequestResponse.data.createCertificatedSubInitiateRequest.firstApproverId, loggedUserId);


                        setPleaseWaitButton(false);
                        toast.success('Data Added Successfully.');
                        
                        // if (certificatedSubReqIsSuperadmin) {
                        //     navigateTo('/substitute_request_certificated/SuperAdminDashboard');
                        // }else{
                        //     navigateTo("/substitute_request_certificated");
                        // }
                        if (previousRoute?.[0]) {
                            navigateTo(previousRoute?.[0]);
                        }else{
                        navigateTo("/substitute_request_certificated");
                        }
                    }

                } catch (error) {
                    console.log('Error saving CertificatedSubInitiateRequestResponse', error);
                }
                //aws amplify data submit in database code end.
            }
        }
        }
    }
    //onSubmit Click Function end.

    //useEffect Functions Start
    const loadInformationForInitiateNewReport = async () => {

        //SET AWS Configuration
        AWS.config.update({
            accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
            secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
            region: process.env.REACT_APP_AWS_Region,
        });

        //1. get all users from aws cognito
        const cognito = new AWS.CognitoIdentityServiceProvider();
        var params =
        {
            UserPoolId: awsmobile.aws_user_pools_id,
            Limit: 60
        };

        //set employee list
        let finalUserList = [];
        cognito.listUsers(params, (err, data) => {
            if (err) {
                console.log("Error in Cognito User Fetch", err);
            } else {

                var newRes = []
                let userName = '', userEmail = '', userCode = '';
                let firstName = '';
                let lastName = '';
                let sub = '';
                let userRole = '';

                (data.Users).forEach((user, i) => {

                    // if (user.Attributes.find(attr => attr.Name === "custom:certiSubReIsApprover" || attr.Name === "custom:certiSubReqIsPayroll") != undefined) {
                    userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
                    sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
                    firstName = user.Attributes.find(attr => attr.Name === "custom:firstName")?.Value;
                    lastName = user.Attributes.find(attr => attr.Name === "custom:lastName")?.Value;
                    userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
                    userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
                    userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;

                    let obj = {
                        "userId": sub,
                        "name": userName,
                        "email": userEmail,
                        "userCode": userCode,
                        "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
                    }
                    newRes.push(obj);
                }
                );

                //get only those users are without admin
                let usersWithoutAdminAndLoggedUser = [];
                const loggedUserId = reactLocalStorage.get('loggedUserId');

                setGloballyLoggedUserId(loggedUserId);


                newRes.map((currentItem) => {
                    if (currentItem.role !== 'Admin' && currentItem.role !== 'Payroll'
                        && currentItem.userId !== loggedUserId) {
                        usersWithoutAdminAndLoggedUser.push(currentItem);
                    }
                })

                usersWithoutAdminAndLoggedUser.map((currentItem) => {
                    let name = currentItem.userCode ? `${currentItem.name} (${currentItem.userCode})` : currentItem.name;
                    let obj = { name: name, code: currentItem.userId };
                    finalUserList.push(obj);
                })
                setUserList();
                // setFirstApproverList(finalUserList);
            }
        });

        //2.FundingAccountType master data
        let finalFundingAccountTypeList = [{ name: "Other", code: "O" }];
        try {
            // var fundingAccountTypeResponses = await DataStore.query(FundingAccountType, Predicates.ALL, {
            //     sort: s => s.fundingAccountType(SortDirection.ASCENDING)
            // });


            var fundingAccountTypeResponses = await graphQLGetAllData("listFundingAccountTypes")
            fundingAccountTypeResponses = fundingAccountTypeResponses.sort((a, b) => a.fundingAccountType.localeCompare(b.fundingAccountType));

            fundingAccountTypeResponses.map((currentItem) => {
                let obj = {};
                if (currentItem.isSpecify) {
                    obj = { name: currentItem.fundingAccountType + '(Specify)', code: currentItem.id };
                } else {
                    obj = { name: currentItem.fundingAccountType, code: currentItem.id };
                }
                finalFundingAccountTypeList.push(obj);
            })
            setFundingAccountTypeList(finalFundingAccountTypeList);


        } catch (err) {
            console.log("Error while fetching FundingAccountType", err);
        }

        // get school list
        // var SchoolResponses = await DataStore.query(Schools, Predicates.ALL, {
        //     sort: s => s.name(SortDirection.ASCENDING)
        // });

        var SchoolResponses = await graphQLGetAllData("listSchools")
        SchoolResponses = SchoolResponses.sort((a, b) => a.name.localeCompare(b.name));

        var schoolArray = []; schoolArray = ConvertResponseForSelect(SchoolResponses); setSchoolList(schoolArray);

        if (SchoolResponses && finalFundingAccountTypeList.length > 0) {  //&& finalUserList.length > 0
            // setSecondApproverList(finalUserList);
            //  setPayrollList(finalUserList);
            // setIsLoadData(true);

            loadPayrollUsers();

            //check is Edit or New
            if (reportId !== null) {
                // setEditMode(true);
                BindList(SchoolResponses, finalUserList, finalFundingAccountTypeList);
            }
            // else{
            //     setIsLoadData(true);
            // }
        }

    }


    async function loadPayrollUsers() {

        try {
            const cognito = new AWS.CognitoIdentityServiceProvider();
            var params =
            {
                UserPoolId: awsmobile.aws_user_pools_id,
                Limit: 60,
                "Filter": "email ^= \"" + searchPayroll + "\"",
            };


            cognito.listUsers(params, (err, data) => {
                if (err) {
                    toast.error(err.message);
                } else {
                    var newRes = []
                    let userRole = '', userName = '', userEmail = '', userCode = '', sub = '';
                    (data.Users).forEach((user, i) => {
                        userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
                        userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
                        sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
                        userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
                        userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
                        let obj = {
                            "userId": sub,
                            "code": sub,
                            "name": userName,
                            "email": userEmail,
                            "usercode": userCode,
                            "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
                        }
                        newRes.push(obj);
                    }
                    );
                    setPayrollList(newRes);
                    const finalPayroll = newRes.length ? newRes[0] : newRes[0];
                    setSelectedPayroll(finalPayroll)

                }
            });


        } catch (e) {
            toast.error(e.message);
        }
    }

    async function BindList(SchoolResponses, finalUserList, finalFundingAccountTypeList) {

        //get particular report Id data from
        try {

            const loggedUserId = reactLocalStorage.get('loggedUserId');
            // const certificatedSubInitiateRequestResponse = await DataStore.query(CertificatedSubInitiateRequest,
            //     (c) => c.id.eq(reportId),
            // );
            let particularReportTransactionCycleResponse = await graphQLGetAllData("listCertificatedSubRequestTransactionCycles", [{ reportId: { eq: reportId } }])
            let particularReportTransactionCycleResponse1 = particularReportTransactionCycleResponse.sort((b, a) => a.createdAt.localeCompare(b.createdAt));
            const certificatedSubInitiateRequestResponse = await graphQLFindRecordById("getCertificatedSubInitiateRequest", reportId)
            console.log('certificatedSubInitiateRequestResponse :>> ', certificatedSubInitiateRequestResponse);
            console.log('loggedUserId :>> ', loggedUserId);
            console.log('particularReportTransactionCycleResponse :>> ', particularReportTransactionCycleResponse1);


            if(reportId && lastPart === 'SuperAdminDashboard'){
                if(certificatedSubInitiateRequestResponse){                   
                    if (particularReportTransactionCycleResponse1.length){
                        let currentRecord = particularReportTransactionCycleResponse1[0].to_Employee_Id;
                        if(currentRecord === certificatedSubInitiateRequestResponse?.firstApproverId){
                            setISDisableSiteAdmin(false);
                            setISDisableBudgetClerk(false);
                            setISDisableBudgetManager(false);
                        }
                        else if(currentRecord === certificatedSubInitiateRequestResponse?.secondApproverId){
                            setISDisableSiteAdmin(true);
                            setISDisableBudgetClerk(false);
                            setISDisableBudgetManager(false);
                        }
                        else if(currentRecord === certificatedSubInitiateRequestResponse?.thirdApproverId){
                            setISDisableSiteAdmin(true);
                            setISDisableBudgetClerk(true);
                            setISDisableBudgetManager(false);
                        }
                        else if(currentRecord === certificatedSubInitiateRequestResponse?.payrollId){
                            setISDisableSiteAdmin(true);
                            setISDisableBudgetClerk(true);
                            setISDisableBudgetManager(true);
                        }
                        else{
                            setISDisableSiteAdmin(false);
                            setISDisableBudgetClerk(false);
                            setISDisableBudgetManager(false);
                        }
                            
                        }
                    }
                }
            


            //#436 & #438=>New Enhancement start
            if (loggedUserId == certificatedSubInitiateRequestResponse?.submittedBy) {
                setApproverFieldsDisabled(true);
            }
            //#436 & #438=>New Enhancement end

            //get number of substitute from CertificatedSubRequestTeacherData table
            // var certificatedSubRequestTeacherDataResponses = await DataStore.query(CertificatedSubRequestTeacherData, (c) => c.reportId.eq(reportId));
            var certificatedSubRequestTeacherDataResponses = await graphQLGetAllData("listCertificatedSubRequestTeacherData", [{ reportId: { eq: reportId } }])
            certificatedSubRequestTeacherDataResponses = certificatedSubRequestTeacherDataResponses.sort((a, b) => a.createdAt.localeCompare(b.createdAt));

            SchoolResponses.map((currentSchool) => {
                if (currentSchool.id === certificatedSubInitiateRequestResponse.schoolOrDeptId) {
                    setSelectedSchool({ name: currentSchool.name, code: currentSchool.id });
                    //get Particular school id employees
                    getSpecificSchoolOrDeptEmployees({ value: { name: currentSchool.name, code: currentSchool.id } });

                    setInitiateNewReportDate(new Date(certificatedSubInitiateRequestResponse.reportDate));
                }
            });

            setSpecifyPurposeValue(certificatedSubInitiateRequestResponse.purposeOfReport);
            setAssighmentTitle(certificatedSubInitiateRequestResponse.assighmentTitle);

            if (certificatedSubInitiateRequestResponse.firstApproverId) {

                // let empName = await DataStore.query(Employee, (c) => c.user_Id.eq(certificatedSubInitiateRequestResponse.firstApproverId));

                let empName = allEmployeeList.find(o => o.user_Id === certificatedSubInitiateRequestResponse.firstApproverId)

                let name = empName.employee_code ? `${empName.employee_name} (${empName.employee_code})` : empName.employee_name;

                let objFirstApprover = { name: name, code: certificatedSubInitiateRequestResponse.firstApproverId }
                //Default selection
                setSelectedFirstApprover(objFirstApprover)
            }

            if (certificatedSubInitiateRequestResponse.secondApproverId) {

                // let empName = await DataStore.query(Employee, (c) => c.user_Id.eq(certificatedSubInitiateRequestResponse.secondApproverId));
                let empName = allEmployeeList.find(o => o.user_Id === certificatedSubInitiateRequestResponse.secondApproverId)

                let name = empName.employee_code ? `${empName.employee_name} (${empName.employee_code})` : empName.employee_name;

                let objFirst = { name: name, code: certificatedSubInitiateRequestResponse.secondApproverId }
                setSelectedSecondApprover(objFirst)
            }

            if (certificatedSubInitiateRequestResponse.thirdApproverId) {

                // let empName = await DataStore.query(Employee, (c) => c.user_Id.eq(certificatedSubInitiateRequestResponse.thirdApproverId));
                let empName = allEmployeeList.find(o => o.user_Id === certificatedSubInitiateRequestResponse.thirdApproverId)

                let name = empName.employee_code ? `${empName.employee_name} (${empName.employee_code})` : empName.employee_name;

                let objFirst = { name: name, code: certificatedSubInitiateRequestResponse.thirdApproverId }
                setSelectedThirdApprover(objFirst)
            }

            let existingPayroll;
            if (certificatedSubInitiateRequestResponse.payrollId) {
                const cognito = new AWS.CognitoIdentityServiceProvider();
                try {
                    existingPayroll = await cognito.adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: certificatedSubInitiateRequestResponse.payrollId, }).promise();
                } catch (e) {
                }

                let name = existingPayroll ? existingPayroll.UserAttributes.find(attr => attr.Name === "name")?.Value : '';
                let usercode = existingPayroll ? existingPayroll.UserAttributes.find(attr => attr.Name === "custom:userCode")?.Value : '';

                name = usercode ? `${name} (${usercode})` : name;
                let objFirst = { name: name, code: certificatedSubInitiateRequestResponse.payrollId }

                setSelectedPayroll(objFirst);
                setPayrollList([objFirst])

            }

            // var certificatedSubRequestFundingAccountDetailsResponses = await DataStore.query(CertificatedSubRequestFundingAccountDetails, (c) => c.reportId.eq(reportId));

            var certificatedSubRequestFundingAccountDetailsResponses = await graphQLGetAllData("listCertificatedSubRequestFundingAccountDetails", [{ reportId: { eq: reportId } }])
            certificatedSubRequestFundingAccountDetailsResponses = certificatedSubRequestFundingAccountDetailsResponses.sort((a, b) => a.createdAt.localeCompare(b.createdAt));

            if (certificatedSubRequestTeacherDataResponses?.length > 0 && certificatedSubRequestFundingAccountDetailsResponses?.length > 0) {

                let finalTeacherData = [];
                for (let i = 0; i < certificatedSubRequestTeacherDataResponses.length; i++) {

                    //get teacher name from Employee master using teacherId attribute.
                    // var employeeResponses = await DataStore.query(Employee, (c) => c.id.eq(certificatedSubRequestTeacherDataResponses[i].teacherId));

                    var employeeResponses = allEmployeeList.find(o => o.id === certificatedSubRequestTeacherDataResponses[i].teacherId)

                    //for dates call CertificatedSubRequestSpecificTeacherDates table data
                    // var certificatedSubRequestSpecificTeacherDatesResponses = await DataStore.query(CertificatedSubRequestSpecificTeacherDates, (c) => c.teacherId.eq(certificatedSubRequestTeacherDataResponses[i].id));

                    var certificatedSubRequestSpecificTeacherDatesResponses = await graphQLGetAllData("listCertificatedSubRequestSpecificTeacherDates", [{ teacherId: { eq: certificatedSubRequestTeacherDataResponses[i].id } }])

                    let particularTeacherDates = [];
                    for (let j = 0; j < certificatedSubRequestSpecificTeacherDatesResponses.length; j++) {
                        //particularTeacherDates.push(new Date(certificatedSubRequestSpecificTeacherDatesResponses[j].date));
                        //updating for date issue in timezone
                        particularTeacherDates.push(new Date(moment(certificatedSubRequestSpecificTeacherDatesResponses[j].date).format('ddd MMM D YYYY HH:mm:ss [GMT]ZZ (z)')))
                    }
                    console.log("🚀 ~ file: initiateNewReport.js:1850 ~ BindList ~ employeeResponses: 😋😋😋😋😋", employeeResponses)
                    if (employeeResponses) {
                        let teacherName=(employeeResponses.employee_code=="")?{ name: employeeResponses.employee_name, code: employeeResponses.id }:
                        { name: employeeResponses.employee_name + ' ' + '(' + employeeResponses.employee_code + ')', code: employeeResponses.id }
                        let obj = {
                            // teacherName: { name: employeeResponses.employee_name + ' ' + '(' + employeeResponses.employee_code + ')', code: employeeResponses.id },
                            teacherName: teacherName,
                            datesNeeded: particularTeacherDates,
                            indicateIf: { name: certificatedSubRequestTeacherDataResponses[i].indicateIf, code: certificatedSubRequestTeacherDataResponses[i].indicateIf },
                            gradeOrSubject: certificatedSubRequestTeacherDataResponses[i].gradeOrSubject,
                            note: certificatedSubRequestTeacherDataResponses[i].note
                        }
                        finalTeacherData.push(obj);
                    }

                }

                //get particular id funding data from CertificatedSubRequestFundingAccountDetails
                let finalFundingAccountData = [];
                for (let k = 0; k < certificatedSubRequestFundingAccountDetailsResponses.length; k++) {

                    let obj1;
                    finalFundingAccountTypeList.map((fundItem) => {
                        if (fundItem.code === certificatedSubRequestFundingAccountDetailsResponses[k].fundingAccountTypeId) {
                            obj1 = {
                                fundingAccount: fundItem,
                                programAccountNumber: certificatedSubRequestFundingAccountDetailsResponses[k].accountNumber, remarks: certificatedSubRequestFundingAccountDetailsResponses[k].remarks,
                                percentageValue: certificatedSubRequestFundingAccountDetailsResponses[k].percentage
                            };
                        }
                    })

                    finalFundingAccountData.push(obj1);
                }
                // finalTeacherData = finalTeacherData.sort((a, b) => a.teacherName.localeCompare(b.teacherName));
                // finalTeacherData = finalTeacherData.sort((a, b) => (a.teacherName ?? "").localeCompare(b.teacherName ?? ""));
                console.log("🚀 ~ file: initiateNewReport.js:1883 ~ BindList ~ finalTeacherData: 😋😋😋😋😋", finalTeacherData)
                setTeachers(finalTeacherData);
                setFundingAccounts(finalFundingAccountData);
                // setIsLoadEditData(true);

            }

        } catch (error) {
            console.log("Error retrieving certificatedSubInitiateRequestResponse", error);
        }
    }
    //useEffect Functions End

    // useEffect(() => {
    //     loadInformationForInitiateNewReport();
    //     setUserList();
    // }, [])

    const getMasterData = async () => {
        // let schoolsArray = await graphQLGetAllData("listSchools")
        // setSchoolList(schoolsArray)

        let employeeArray = await graphQLGetAllData("listEmployees")
        employeeArray = employeeArray.sort((a, b) => (a.employee_name?.toLowerCase() ?? "").localeCompare(b.employee_name?.toLowerCase() ?? ""));

        setAllEmployeeList(employeeArray)
        //unique approver
        let employeeData = await getUniqueEmployeeList(employeeArray)
        setEmployeeUniqList(employeeData)
        //load budget clerk
        //let budgetClerk = await graphQLGetAllData("listEmployees", [{ designation: { eq: "BUDGET_CLERK" } }])
        //budgetClerk = budgetClerk.sort((a, b) => (a.employee_name?.toLowerCase() ?? "").localeCompare(b.employee_name?.toLowerCase() ?? ""));
        //setClerkList(budgetClerk)
        //const clerkArray = budgetClerk.map(item => ({ name: item.employee_code? `${item.employee_name} (${item.employee_code})` : item.employee_name, code: item.employee_code }));
        //setBudgetClerkList(clerkArray)	

        //load budget manager
        // let budgetManager = await graphQLGetAllData("listEmployees", [{ designation: { eq: "BUDGET_MANAGER" } }])
        // budgetManager = budgetManager.sort((a, b) => (a.employee_name?.toLowerCase() ?? "").localeCompare(b.employee_name?.toLowerCase() ?? ""));
        // setManagerList(budgetManager)
        //const managArray = budgetManager.map(item => ({ name: item.employee_code? `${item.employee_name} (${item.employee_code})` : item.employee_name, code: item.employee_code }));
        //setBudgetManagerList(managArray)

        setIsMasterDataLoaded(true)
    }

    useEffect(() => {
        checkApplicationAccessibility()
        getMasterData();
    }, []);

    useEffect(() => {
        if (isMasterDataLoaded === true) {
            loadInformationForInitiateNewReport();
            setUserList();
            setUserListByClerk();
            setUserListByManager();
        }
    }, [isMasterDataLoaded]);


    return isAuthenticated ? (
        <>
            <Layout pageTitle="Homepage" 
            activeMenu={"Initiator"} 
            // activeMenu={certificatedSubReqIsSuperadmin ? "SuperAdmin" :"Initiator"} 
            appId='SUBSTITUTE_REQUEST_CERTIFICATED'
             reDirectUrl={"/substitute_request_certificated/SuperAdminDashboard"}
             IsSuperadmin={certificatedSubReqIsSuperadmin}
            >
                <div className="">
                    <div className="pt-24 md:pt-28 xl:pt-[2.083vw]">
                        <div className="">

                            <div className="text-[#113699] font-semibold -tracking-[0.02em] text-xl xl:text-[1.042vw]">
                                <h3>{(isEditMode) ? 'Edit ' : 'Initiate '} Substitute Request Certificated</h3>
                            </div>

                            {/* {
                                (isLoadEditData || isLoadData) ? */}
                            <div className='border borer-[red] grid grid-cols-12 gap-4'>
                                <div className='col-span-12 md:col-span-4 px-4'>

                                    <div className="w-full">
                                        <label htmlFor="employee" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Assignment Title <span className='text-[red] pl-0.2'>*</span></label>
                                        <div className="relative">
                                            <InputText id="employee"
                                                value={assighmentTitle}
                                                onChange={(e) => { setAssighmentTitle(e.target.value); }}
                                                placeholder="Enter Assignment Title" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }} />
                                        </div>
                                    </div>

                                    <div className="w-full">
                                        <label htmlFor="dept" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">School or Department <span className='text-[red] pl-0.2'>*</span></label>
                                        <div className="relative">
                                            <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                            <Dropdown id="dept" value={selectedSchool}
                                                showClear
                                                onChange={(e) => {
                                                    if(reportStatus === "copyReport"){
                                                        let isConfirm=window.confirm("Alert All data in the preview section will be deleted. Confirm your choice below.");
                                                        if(isConfirm){
                                                            setTeachers([{ teacherName: '', datesNeeded: [], indicateIf: '', gradeOrSubject: '', note: '' }]);
                                                            getSpecificSchoolOrDeptEmployees(e);
                                                        }else{
                                                            return 0;
                                                        }
                                                    }
                                                    else if(lastPart === "SuperAdminDashboard"){
                                                        let isConfirm=window.confirm("Alert All data in the preview section will be deleted. Confirm your choice below.");
                                                        if(isConfirm){
                                                            setTeachers([{ teacherName: '', datesNeeded: [], indicateIf: '', gradeOrSubject: '', note: '' }]);
                                                            getSpecificSchoolOrDeptEmployees(e);
                                                        }else{
                                                            return 0;
                                                        }
                                                    }
                                                    else{
                                                    getSpecificSchoolOrDeptEmployees(e);
                                                }

                                                }}
                                                filter
                                                // disabled={isEmpDisable ? isEmpDisable : disabled}
                                                options={schoolList} optionLabel="name" placeholder="Select" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                            />
                                        </div>
                                    </div>

                                    <div className="w-full">
                                        <div className="">
                                            <label htmlFor="username" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Submitted On </label> </div>
                                        <div className="w-full">
                                            <div className="relative custp-calender">
                                                <i className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"
                                                    onClick={() => openCalendar("submittedOn")}
                                                ></i>
                                                <i className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"
                                                    onClick={() => openCalendar("submittedOn")}
                                                ></i>
                                                <div className="card justify-content-center">
                                                    <Calendar
                                                        ref={inputRef2}
                                                        // onChange={(e) => {
                                                        //     setInitiateNewReportDate(e.value)
                                                        // }}
                                                        disabled
                                                        value={initiateNewReportDate}
                                                        // disabled={isEmpDisable ? isEmpDisable : disabled}
                                                        placeholder="Select Date"
                                                        className="w-full h-11" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="w-full">
                                        {console.log('reportStatus :>> ', reportStatus)}
                                        <label htmlFor="dept" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Site Admin/Dept. Head (First Approver) <span className='text-[red] pl-0.2'>*</span></label>
                                        <div className="relative">
                                            <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                            <Dropdown
                                                id="dept"
                                                showClear
                                                value={selectedFirstApprover}
                                                onChange={(e) => {
                                                    setSelectedFirstApprover(e.value);
                                                    setIsValueChange(true)
                                                }}
                                                filter
                                                onKeyDown={e => {
                                                    setUserList(e)
                                                }}
                                                options={allApproverList}
                                                optionLabel="name"
                                                placeholder="Select Site Admin/Dept"
                                                className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5"
                                                style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                                
                                                disabled={
                                                    ( isDisableSiteAdmin || lastPart != "SuperAdminDashboard" && (reportStatus === SUB_CERTIFICATED_STATUS.REJECTED ||
                                                        reportStatus === 'EditByAp')) ? true :  false
                                                        // (lastPart === "SuperAdminDashboard")) ? true : (approverFieldsDisabled ? true : false)
                                                }
                                            />

                                        </div>
                                    </div>

                                    <div className="w-full">
                                        <label htmlFor="dept" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Budget Clerk (Second Approver)</label>
                                        <div className="relative">
                                            <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                            <Dropdown id="dept" value={selectedSecondApprover}
                                                // showClear
                                                onChange={(e) => {
                                                    if (e.value) {
                                                        setSelectedSecondApprover(e.value)
                                                    } else {
                                                        setSelectedSecondApprover(null)
                                                    }
                                                    setIsValueChange(true)

                                                }}
                                                filter
                                                onKeyDown={e => {
                                                    setUserListByClerk(e)
                                                }}
                                                valueTemplate={selectedBudgeClerkTemplate}
                                                // disabled={isEmpDisable ? isEmpDisable : disabled}
                                                options={budgetClerkList}
                                                optionLabel="name"
                                                placeholder="Select Budget Clerk"
                                                className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5"
                                                style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                                disabled={
                                                    (isDisableBudgetClerk || lastPart != "SuperAdminDashboard" && (reportStatus === SUB_CERTIFICATED_STATUS.REJECTED ||
                                                        reportStatus === 'EditByAp') ) ? true :  false
                                                        // (lastPart === "SuperAdminDashboard")) ? true : (approverFieldsDisabled ? true : false)
                                                }
                                                // disabled={(reportStatus == SUB_CERTIFICATED_STATUS.REJECTED || reportStatus == 'EditByAp') ? (!approverFieldsDisabled ? true : false) : false}

                                            />
                                        </div>
                                    </div>


                                    {
                                        (reportStatus == SUB_CERTIFICATED_STATUS.REJECTED) ?
                                            (!approverFieldsDisabled) ?
                                                <div className="w-full">
                                                    <label htmlFor="dept" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Budget Manager/Director (Third Approver)</label>
                                                    <div className="relative">
                                                        <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                                        <Dropdown id="dept" value={selectedThirdApprover}
                                                            // disabled={(reportStatus == SUB_CERTIFICATED_STATUS.REJECTED || lastPart === "SuperAdminDashboard") ? true : false}
                                                            disabled={
                                                                (lastPart != "SuperAdminDashboard" && (reportStatus === SUB_CERTIFICATED_STATUS.REJECTED ||
                                                                    reportStatus === 'EditByAp') || isDisableBudgetManager) ? true :  false
                                                                    // (lastPart === "SuperAdminDashboard")) ? true : (approverFieldsDisabled ? true : false)
                                                            }
                                                            className='w-full h-11 rounded-md border border-[#E4E7EC] pl-5'
                                                            options={budgetManagerList} optionLabel="name" placeholder="Select Budget Manager/Director" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                                        />
                                                    </div>
                                                </div> :
                                                <div className="w-full">
                                                    <label htmlFor="dept" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Budget Manager/Director (Third Approver)</label>
                                                    <div className="relative">
                                                        <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                                        <Dropdown id="dept" value={selectedThirdApprover} onChange={(e) => {
                                                            console.log('e.value 😂😂😂😂😂', e.value)
                                                            if (e.value) {
                                                                setSelectedThirdApprover(e.value)
                                                            } else {
                                                                setSelectedThirdApprover(null)
                                                            }
                                                            setIsValueChange(true)
                                                        }}
                                                            showClear
                                                            filter

                                                            onKeyDown={e => {
                                                                setUserListByManager(e)
                                                            }}
                                                            // disabled={(!selectedSecondApprover || lastPart === "SuperAdminDashboard") ? true : false}
                                                            // disabled={(!selectedSecondApprover) ? true : false}
                                                            disabled={
                                                                (lastPart != "SuperAdminDashboard" && (reportStatus === SUB_CERTIFICATED_STATUS.REJECTED ||
                                                                    reportStatus === 'EditByAp') || isDisableBudgetManager) ? true :  false
                                                                    // (lastPart === "SuperAdminDashboard")) ? true : (approverFieldsDisabled ? true : false)
                                                            }
                                                            className='w-full h-11 rounded-md border border-[#E4E7EC] pl-5'
                                                            options={budgetManagerList} optionLabel="name" placeholder="Select Budget Manager/Director" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                                        />
                                                    </div>
                                                </div> :

                                            (reportStatus === "EditByAp") ?
                                                <div className="w-full">
                                                    <label htmlFor="dept" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Budget Manager/Director (Third Approver)</label>
                                                    <div className="relative">
                                                        <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                                        <Dropdown id="dept"
                                                            value={selectedThirdApprover}
                                                            className='w-full h-11 rounded-md border border-[#E4E7EC] pl-5'
                                                            options={budgetManagerList} optionLabel="name" placeholder="Select Budget Manager/Director" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                </div>

                                                :
                                                <div className="w-full">
                                                    <label htmlFor="dept" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Budget Manager/Director (Third Approver)</label>
                                                    <div className="relative">
                                                        <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                                        <Dropdown id="dept" value={selectedThirdApprover} onChange={(e) => {
                                                            console.log('e.value 😂😂😂😂😂', e.value)
                                                            if (e.value) {
                                                                setSelectedThirdApprover(e.value)
                                                            } else {
                                                                setSelectedThirdApprover(null)
                                                            }
                                                            setIsValueChange(true)
                                                        }}
                                                            showClear
                                                            filter

                                                            onKeyDown={e => {
                                                                setUserListByManager(e)
                                                            }}
                                                            // disabled={(!selectedSecondApprover) || lastPart === "SuperAdminDashboard" ? true : false}
                                                            disabled={
                                                                (lastPart != "SuperAdminDashboard" && (reportStatus === SUB_CERTIFICATED_STATUS.REJECTED ||
                                                                    reportStatus === 'EditByAp') || isDisableBudgetManager) ? true :  false
                                                                    // (lastPart === "SuperAdminDashboard")) ? true : (approverFieldsDisabled ? true : false)
                                                            }
                                                            className='w-full h-11 rounded-md border border-[#E4E7EC] pl-5'
                                                            options={budgetManagerList} optionLabel="name" placeholder="Select Budget Manager/Director" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                                        />
                                                    </div>
                                                </div>
                                    }


                                    {/*<div className="w-full">
                                        <label htmlFor="dept" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Select Sub Desk <span className='text-[red] pl-0.2'>*</span></label>
                                        <div className="relative">
                                            <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                            <Dropdown id="dept" value={selectedPayroll}
                                                onChange={(e) => {
                                                    setSelectedPayroll(e.value)
                                                }}
                                                filter
                                                onKeyDown={e => {
                                                    setEmpList(e, "payroll")
                                                }}
                                                // disabled={isEmpDisable ? isEmpDisable : disabled}
                                                options={payrollList} optionLabel="name" placeholder="Select Sub Desk" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                            />
                                        </div>
							</div>*/}


                                </div>

                                <div className='col-span-12 md:col-span-8 mt-[20px] xl:mt-[1.042vw] mr-[20px] xl:mr-[1.042vw]'>

                                    <div>

                                        {
                                            teachers.map((currentTeacherDetails, index) => (
                                                <div key={index} id={`delete_${index}`} className='border border-[orange]] lg:grid lg:grid-cols-3 md:block gap-4 p-4 mb-4 relative'>
                                                    {
                                                        teachers.length > 1 ?
                                                            <div onClick={() => removeDiv(index)} className='absolute top-2 right-5'><i
                                                                class="pi pi-trash printicon text-[gray]"></i></div> :
                                                            <div className='absolute top-2 right-5 text-[gray]'></div>

                                                    }

                                                    <div className="w-full">
                                                        <label htmlFor="dept" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Teacher(s) Name <span className='text-[red] pl-0.2'>*</span></label>
                                                        <div className="relative grid grid-cols-12 gap-2">
                                                            <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                                            <Dropdown id="dept" value={currentTeacherDetails.teacherName}
                                                                showClear
                                                                onChange={(e) => handleTeacherNameChange(index, e)}
                                                                filter
                                                                // disabled={isEmpDisable ? isEmpDisable : disabled}
                                                                options={employeeList}
                                                                optionLabel="name"
                                                                placeholder="Select Teacher"
                                                                className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5 col-span-11"
                                                                style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                                            />
                                                            <div onClick={(e) => setOpenNewEmployee(true)} className='cursor-pointer text-[30px] '>
                                                                {/* <i className='gusd-pluse-circle' style = {{color: "lightgray",fontSize: "20px", margin: "3px",position:"relative", bottom:"6px"}}></i> */}
                                                                <Tooltip target=".icon-tooltip" content="Add Employee" position="top" className="custom-tooltip-content" />
                                                                <i className='icon-tooltip gusd-pluse-circle col-span-1' style={{ color: "lightgray", fontSize: "20px", margin: "3px", position: "relative", bottom: "6px" }}></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* Add New Employee Popup */}
                                                    <Dialog
                                                        header="Add New Employee" draggable={false} className='add_New_Employee'
                                                        visible={openNewEmployee}
                                                        style={{ width: "30vw" }}

                                                        onHide={() => {
                                                            setOpenNewEmployee(false);

                                                        }}
                                                    // footer={footerContentForReqReject}
                                                    >
                                                        <div className="m-0">

                                                            <div className="font-medium text-sm mb-2 mt-3">School/Department <span className="text-[red] pl-0.2">*</span></div>
                                                            <Dropdown id="dept" value={selectedSchool}
                                                                onChange={(e) => { getSpecificSchoolOrDeptEmployees(e); }}
                                                                filter
                                                                // disabled={disabled}
                                                                options={schoolList} optionLabel="name" placeholder="Select School/Department" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                                            />
                                                            {/* <div className="font-medium text-[18px] mb-2 mt-3">Employee Name <span className="text-[red] pl-0.2">*</span></div>
                                                            <InputText
                                                                value={NewEmployeeName}
                                                                placeholder=""
                                                                onChange={e => { setNewEmployeeName(e.target.value) }}
                                                                className="w-full"
                                                            /> */}
                                                            <div className="font-medium text-sm mb-2 mt-3">First Name <span className="text-[red] pl-0.2">*</span></div>
                                                            <InputText
                                                                value={newEmpFirstName}
                                                                placeholder="Enter First Name"
                                                                onChange={e => { setNewEmpFirstName(e.target.value) }}
                                                                className="w-full"
                                                            />
                                                            <div className="font-medium text-sm mb-2 mt-3">Last Name <span className="text-[red] pl-0.2">*</span></div>
                                                            <InputText
                                                                value={newEmpLastName}
                                                                placeholder="Enter Last Name"
                                                                onChange={e => { setNewEmpLastName(e.target.value) }}
                                                                className="w-full"
                                                            />
                                                            {/* <div className="font-medium text-[18px] mb-2 mt-3">Select Role 
                                        <span className="text-[red] pl-0.2">*</span>
                                        </div>
                                        <Dropdown value={newEmpSelectedRole} onChange={(e) => setNewEmpSelectedRole(e.value)} options={rolesArray} optionLabel="name"
                                            placeholder="Select a Role" className="w-full md:w-14rem" />

                                        <div className="font-medium text-[18px] mb-2 mt-3">Designation<span className="text-[red] pl-0.2">*</span></div>
                                        <Dropdown value={newEmpSelectedDesignation} onChange={(e) => setNewEmpSelectedDesignation(e.value)} options={designationForAllApps} optionLabel="name"
                                            placeholder="Select a Designation" className="w-full md:w-14rem" /> */}
                                                            {/* -------------------------------- */}



                                                            <div className="font-medium text-sm mb-2 mt-3">Employee Code <span className="text-[red] pl-0.2">*</span></div>
                                                            <InputText
                                                                value={NewEmployeeCode}
                                                                placeholder="Enter Employee Code"
                                                                onChange={e => { setNewEmployeeCode(e.target.value) }}
                                                                className="w-full"
                                                            />

                                                            <div className="font-medium text-sm mb-2 mt-3 ">Employee Email Address <span className="text-[red] pl-0.2">*</span></div>
                                                            <InputText
                                                                value={NewEmployeeEmail}
                                                                placeholder="Enter Employee Email Address"
                                                                onChange={e => { setNewEmployeeEmail(e.target.value) }}
                                                                className="w-full"
                                                            />
                                                        </div>
                                                        <div className='flex justify-between gap-2 mt-3'>
                                                            <Link to="" onClick={() => { setOpenNewEmployee(false); }}
                                                                className='text-[#344054] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer'>
                                                                <i class="pi pi-times"></i><span>Cancel</span></Link>

                                                            <Link to="" onClick={() => { AddNewEmployee() }}
                                                                className='text-[#039855] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer'>
                                                                <i class="pi pi-check"></i><span>Add</span></Link>

                                                        </div>
                                                    </Dialog>

                                                    <div className="w-full">
                                                        <div className="">
                                                            <label htmlFor="username" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Date(s) Needed <span className='text-[red] pl-0.2'>*</span> </label> </div>
                                                        <div className="w-full">
                                                            <div className="relative custp-calender">
                                                                <i className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"
                                                                    onClick={() => openCalendar("DatesNeeded")}
                                                                ></i>
                                                                <i className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"
                                                                    onClick={() => openCalendar("DatesNeeded")}
                                                                ></i>
                                                                <div className="card justify-content-center">
                                                                    <Calendar
                                                                        ref={inputRef1}
                                                                        // onChange={(e) => {
                                                                        //     setTeacherDates(e.value)
                                                                        // }}
                                                                        onChange={(e) => handleTeacherNeededDatesChange(index, e)}
                                                                        value={currentTeacherDetails.datesNeeded}
                                                                        // disabled={isEmpDisable ? isEmpDisable : disabled}
                                                                        selectionMode="multiple" readOnlyInput
                                                                        placeholder="Select Dates"
                                                                        className="w-full h-11" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="w-full">
                                                        <label htmlFor="dept" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Indicate If <span className='text-[red] pl-0.2'>*</span></label>
                                                        <div className="relative">
                                                            <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                                            <Dropdown id="dept" value={currentTeacherDetails.indicateIf}
                                                                showClear
                                                                // onChange={(e) => {
                                                                //     setSelectedIndicateIf(e.value)
                                                                // }}
                                                                onChange={(e) => handleTeacherIndicatesIfChange(index, e)}
                                                                filter
                                                                // disabled={isEmpDisable ? isEmpDisable : disabled}
                                                                options={indicateIfList} optionLabel="name" placeholder="Select Indicate If" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="w-full">
                                                        <label htmlFor="employee" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Grade(Elem.) or Subject (Second.) </label>
                                                        <div className="relative">
                                                            <InputText id="employee"
                                                                value={currentTeacherDetails.gradeOrSubject}
                                                                // onChange={(e) => { setGradeOrSubjectValue(e.target.value); }}
                                                                onChange={(e) => handleTeacherGradeOrSubjectChange(index, e)}
                                                                placeholder="Enter Grade Or Subject" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }} />
                                                        </div>
                                                    </div>

                                                    <div className="w-full col-span-2">
                                                        <label htmlFor="employee" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Notes<span className='text-[red] pl-0.2'>*</span></label>
                                                        <div className="relative">
                                                            <InputText id="employee"
                                                                value={currentTeacherDetails.note}
                                                                // onChange={(e) => { setNoteValue(e.target.value); }}
                                                                onChange={(e) => handleTeacherNotesChange(index, e)}
                                                                placeholder="Enter Note" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }} />
                                                        </div>
                                                    </div>

                                                </div>
                                            ))}

                                        <div className="flex gap-2 xl:gap-[0.990vw] items-center justify-end py-4">
                                            <Link onClick={() => handleAddClick("teacherDiv")} to='' className="text-center text-white tableBtn bg-[#1E89EC] radius8">
                                                <i className="gusd-pluse mx-1.5 "></i> Add More</Link>
                                        </div>
                                    </div>


                                    <div className="w-full col-span-3 py-4">
                                        <label htmlFor="employee" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Specify Purpose  <span className='text-[red] pl-0.2'>*</span></label>
                                        <div className="relative">
                                            <InputText id="employee"
                                                value={specifyPurposeValue}
                                                onChange={(e) => { setSpecifyPurposeValue(e.target.value); }}
                                                placeholder="Enter Purpose" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }} />
                                        </div>
                                    </div>

                                    <div>

                                        {
                                            fundingAccounts.map((currentFundAccountDetails, index) => (
                                                <div key={index} id={`deleteFun_${index}`} className='lg:grid lg:grid-cols-3 md:block border border-[orange]] gap-4 p-4 mb-4 relative'>

                                                    {
                                                        fundingAccounts.length > 1 ?
                                                            <div onClick={() => removeDivFun(index)} className='absolute top-2 right-5'><i
                                                                class="pi pi-trash printicon text-[gray]"></i></div> :
                                                            <div className='absolute top-2 right-5 text-[gray]'></div>

                                                    }

                                                    <div className="w-full">
                                                        <label htmlFor="dept" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Select Funding Account <span className='text-[red] pl-0.2'>*</span></label>
                                                        <div className="relative">
                                                            <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                                            <Dropdown id="dept" value={currentFundAccountDetails.fundingAccount}
                                                                showClear
                                                                // onChange={(e) => {
                                                                //     setSelectedFundingAccount(e.value.code)
                                                                // }}
                                                                onChange={(e) => handleSelectFundingAccountChange(index, e)}
                                                                filter
                                                                // disabled={isEmpDisable ? isEmpDisable : disabled}
                                                                options={fundingAccountTypeList} optionLabel="name" placeholder="Select Funding Account" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                                            />
                                                        </div>
                                                    </div>

                                                    {
                                                        currentFundAccountDetails.fundingAccount.name === "Equity,Access & Family Engagement(Specify)" || currentFundAccountDetails.fundingAccount.name === "Other" ?
                                                            <div className="w-full">
                                                                <label htmlFor="employee" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]"> Remarks</label>
                                                                <div className="relative">
                                                                    <InputText id="employee"
                                                                        value={currentFundAccountDetails.remarks}
                                                                        // onChange={(e) => { setAccountNumberValue(e.target.value); }}
                                                                        onChange={(e) => handleSelectRemarkChange(index, e)}

                                                                        placeholder="Type Here" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }} />
                                                                </div>
                                                            </div> : null

                                                    }



                                                    <div className="w-full">
                                                        <label htmlFor="employee" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Program Account No<span className='text-[red] pl-0.2'>*</span></label>
                                                        <div className="relative">
                                                            <InputText id="employee"
                                                                value={currentFundAccountDetails.programAccountNumber}
                                                                // onChange={(e) => { setAccountNumberValue(e.target.value); }}
                                                                onChange={(e) => handleProgramAccountNumberChange(index, e)}
                                                                placeholder="Enter Account Number" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }} />
                                                        </div>
                                                    </div>


                                                    <div className="w-full">
                                                        <label htmlFor="employee" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Percentage</label>
                                                        <InputNumber value={currentFundAccountDetails.percentageValue || null}
                                                            // minFractionDigits={2} maxFractionDigits={2} mode="decimal" step={0.25} min={0} suffix="%"
                                                            minFractionDigits={2} maxFractionDigits={2} mode="decimal" step={0.25} min={0}
                                                            onValueChange={(e) => {
                                                                // onChangePercentage(index, e.value);
                                                                handlePercentageChange(index, e)
                                                            }}
                                                            name="" className="w-full h-11 rounded-md border border-[#E4E7EC]" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }} placeholder="Type here" />

                                                        {/* <div className="relative flex">


                                                            <InputText id="employee"
                                                                value={currentFundAccountDetails.percentageValue}
                                                                // onChange={(e) => { setAccountNumberValue(e.target.value); }}
                                                                onChange={(e) => handlePercentageChange(index, e)}
                                                                placeholder="Enter Percentage %" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }} />

                                                            <i className="mt-4 pi pi-percentage ml-2" style={{ fontSize: '20px', color: "lightgray", }}></i>
                                                        </div> */}
                                                    </div>
                                                </div>
                                            ))}

                                        <div className="flex gap-2 xl:gap-[0.990vw] items-center justify-end py-4">
                                            <Link to='' onClick={() => handleAddClick("fundDiv")} className="text-center text-white tableBtn bg-[#1E89EC] radius8">
                                                <i className="gusd-pluse mx-1.5 "></i> Add More</Link>
                                        </div>
                                    </div>

                                    <div className='flex justify-between'>
                                        <div className='py-4'>
                                            <Link to={previousRoute?.[0] ? previousRoute?.[0] :'/substitute_request_certificated'} className="border text-center tableBtn radius8 p-4"> <i className="mr-1 gusd-arrow-line-right"></i>Previous</Link>
                                        </div>

                                        <div className="flex gap-2 xl:gap-[0.990vw] items-center py-4">

                                            {(reportStatus != SUB_CERTIFICATED_STATUS.REJECTED && reportStatus != "EditByAp") && lastPart != "SuperAdminDashboard"?
                                                <Link
                                                    onClick={() => saveInitiateNewReportInfo("PENDING")}
                                                    className="inline-block text-[#2D5BE5] text-xs xl:text-[0.938vw] font-medium  border border-[#D0D5DD] bg-[#EFF8FF] rounded xl:rounded-lg tableBtn"><i className="pi pi-save mr-1" style={{ fontSize: '1rem' }}></i>Save</Link> : null}
                                            {/* <Link onClick={() => setPreviewShow(true)} className="border text-center tableBtn radius8 p-4"> Preview</Link> */}

                                            <Link onClick={() => setPreviewShow(true)} className="border text-white text-center tableBtn prev radius8 p-3 font-medium border-[#D0D5DD] bg-[#3366FF] rounded-[8px] xl:rounded-[0.417vw] "> <i className='gusd-eye mr-1'></i>Preview</Link>
                                            {/* className="inline-block text-white text-[16px] xl:text-[0.833vw]  tableBtn"> */}

                                            <Link onClick={() => reportId && reportStatus === SUB_CERTIFICATED_STATUS.REJECTED ? saveInitiateNewReportInfo("RESUBMITED") : saveInitiateNewReportInfo("SUBMITTED")} className="text-center text-white tableBtn blue radius8 p-4">{pleaseWaitButton ? 'Please Wait...' : 'Submit'}</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* :
                                    <div className="card flex justify-content-center align-center">
                                        <ProgressSpinner />
                                    </div> */}
                            {/* } */}

                        </div>
                    </div>

                    {/* Initiate New Report confirm Box */}
                    <Dialog header="Submit Request" visible={confirmInitiateNewReport} style={{ width: '30vw' }} onHide={() => setConfirmInitiateNewReport(false)}>
                        <p className="m-0 text-[#0487C8]">
                            <i className='pi pi-check-circle mr-2'></i>
                            <span className='font-medium text-[18px]'>Your Request has been submitted for review,You will be notified of updates.</span>
                        </p>
                        <div className='text-center mt-4'>
                            <Link to={'/substitute_request_certificated'} className='border border-[#1E1E1E] blue px-8 py-1 rounded' onClick={() => { setConfirmInitiateNewReport(false); }}>Ok</Link>
                        </div>
                    </Dialog>

                    {/* preview popup start */}
                    <Dialog className="relative reports-popup" visible={previewShow} position='right'
                        style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => { setPreviewShow(false); setShowReport(false); }} draggable={false} resizable={false}>
                        <div className="grid grid-cols-1 lg:grid-cols-12">
                            <div className="col-span-1 lg:col-span-12 bg-[#F5F6F7] h-auto">
                                <div className="p-5">
                                    <div onClick={() => { setPreviewShow(false); setShowReport(false); }} className="py-3">
                                        <Image src={sideBarRight} alt="user" width="24" height="24" /></div>
                                    {
                                        (!showReport) ?
                                            <div>
                                                <div className="text-[#113699] text-md lg:text-[0.833vw] font-bold">Glendale Unified School District</div>
                                                <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Substitute Request Certificated</div>

                                                <div className="pt-3">
                                                    <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                        <div className="font-medium">School or Department </div>
                                                        <div className="font-semibold ">{selectedSchool?.name}</div>
                                                    </div>
                                                    <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                        <div className="font-medium">Date </div>
                                                        <div className="font-semibold ">{moment(initiateNewReportDate).format('MM/DD/YYYY')}</div>
                                                    </div>

                                                    <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                        <div className="font-medium">Status </div>
                                                        <Tag severity="" value={SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_SITE_ADMIN} className="" style={{ background: '#EBFFF3', color: '#003D19' }}></Tag>
                                                        {/* <div >Approved</div> */}
                                                    </div>
                                                </div>


                                                {
                                                    (teachers.length > 0) ?

                                                        <Table className="certificatedPrintTable">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Teacher(s) Name</TableCell>
                                                                    <TableCell>Date(s) Needed</TableCell>
                                                                    <TableCell>Indicate If</TableCell>
                                                                    <TableCell>Grade(element) or Subject(second)</TableCell>
                                                                    <TableCell>Notes</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>

                                                                {teachers.map((item, i) => (
                                                                    <Fragment>
                                                                        <TableRow>
                                                                            <TableCell className="bg-[#F2F4F7]"
                                                                            >
                                                                                {item.teacherName !== undefined ? item.teacherName.name : ''}
                                                                            </TableCell>
                                                                            <TableCell className="w-[180px]">
                                                                                {item.datesNeeded.map((date, detailIndex) => (

                                                                                    <TableRow className="bg-[#F2F4F7]">
                                                                                        <TableCell>{moment(date).format('MM/DD/YYYY')}</TableCell>
                                                                                    </TableRow>
                                                                                ))}
                                                                            </TableCell>
                                                                            <TableCell className="bg-[#F2F4F7]"
                                                                            >
                                                                                {item.indicateIf !== undefined ? item.indicateIf.name : ''}
                                                                            </TableCell>
                                                                            <TableCell className="bg-[#F2F4F7]"
                                                                            >
                                                                                {item.gradeOrSubject}
                                                                            </TableCell>
                                                                            <TableCell className="bg-[#F2F4F7]"
                                                                            >
                                                                                {item.note}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    </Fragment>
                                                                ))}
                                                            </TableBody>
                                                        </Table>

                                                        : null
                                                }

                                                <div className="pt-3">
                                                    <div className="flex flex-wrap items-center justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                        <div className="font-medium">Purpose</div>
                                                        <div className="font-semibold ">{specifyPurposeValue}</div>
                                                    </div>
                                                    <div className="text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                        <div className="font-medium">Funding Account</div>
                                                        {
                                                            fundingAccounts.map((currentItem, index) => {
                                                                return (
                                                                    <div key={index} className="border p-2">
                                                                        <div className="flex items-center flex-wrap justify-between">
                                                                            <div className="font-light py-3">Department</div>
                                                                            <div className="font-semibold ">{currentItem.fundingAccount?.name}</div>
                                                                        </div>
                                                                        <div className="flex justify-between">
                                                                            <div className="font-light">Remarks</div>
                                                                            <div className="font-semibold ">{currentItem.remarks}</div>
                                                                        </div>
                                                                        <div className="flex justify-between">
                                                                            <div className="font-light">Program Account #</div>
                                                                            <div className="font-semibold ">{currentItem.programAccountNumber}</div>
                                                                        </div>
                                                                        <div className="flex justify-between">
                                                                            <div className="font-light">Percentage</div>
                                                                            <div className="font-semibold ">{currentItem.percentageValue}</div>
                                                                        </div>

                                                                    </div>
                                                                );
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div>
                                                <div className="border m-4">
                                                    <div className='text-center py-8'>
                                                        <Link to={""}><Image src={logoImg} width={"104"} height={"105"} imageClassName='m-auto' /></Link>
                                                        <div>
                                                            <div className="font-bold text-lg">GLENDALE UNIFIED SCHOOL DISTRICT</div>
                                                            <div className="font-semibold text-base">Preparing our students for their future</div>
                                                            <div className="font-light text-sm">
                                                                <div>Office of the Chief Human Resources & Operations Officer</div>
                                                                <div>223 North Jackson St. Glendale, California 91206-4380</div>
                                                                <div>Telephone:818-241-3111,Ext.1256 Fax:818-547-3207</div>
                                                            </div>
                                                        </div>
                                                        <div className="my-4 font-bold text-xl">
                                                            Substitute Request - Certificated
                                                        </div>
                                                    </div>

                                                    <div className="pt-3 mx-8">
                                                        <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                            <div className="font-medium">School or Department </div>
                                                            <div className="font-semibold ">{selectedSchool?.name}</div>
                                                        </div>
                                                        <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                            <div className="font-medium">Date </div>
                                                            <div className="font-semibold ">{moment(initiateNewReportDate).format('MM/DD/YYYY')}</div>
                                                        </div>

                                                        <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                            <div className="font-medium">Status </div>
                                                            <Tag severity="" value={SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_SITE_ADMIN} className="" style={{ background: '#EBFFF3', color: '#003D19' }}></Tag>
                                                            {/* <div >Approved</div> */}
                                                        </div>
                                                    </div>

                                                    <div>


                                                        {
                                                            (teachers.length > 0) ?

                                                                <Table className="certificatedPrintTable">
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell>Teacher(s) Name</TableCell>
                                                                            <TableCell>Date(s) Needed</TableCell>
                                                                            <TableCell>Indicate If</TableCell>
                                                                            <TableCell>Grade(element) or Subject(second)</TableCell>
                                                                            <TableCell>Notes</TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>

                                                                        {teachers.map((item, i) => (
                                                                            <Fragment>
                                                                                <TableRow>
                                                                                    <TableCell className="bg-[#F2F4F7]"
                                                                                    >
                                                                                        {item.teacherName.name}
                                                                                    </TableCell>
                                                                                    <TableCell className="w-[180px]">
                                                                                        {item.datesNeeded.map((date, detailIndex) => (

                                                                                            <TableRow className="bg-[#F2F4F7]">
                                                                                                <TableCell>{moment(date).format('MM/DD/YYYY')}</TableCell>
                                                                                            </TableRow>
                                                                                        ))}
                                                                                    </TableCell>
                                                                                    <TableCell className="bg-[#F2F4F7]"
                                                                                    >
                                                                                        {item.indicateIf.name}
                                                                                    </TableCell>
                                                                                    <TableCell className="bg-[#F2F4F7]"
                                                                                    >
                                                                                        {item.gradeOrSubject}
                                                                                    </TableCell>
                                                                                    <TableCell className="bg-[#F2F4F7]"
                                                                                    >
                                                                                        {item.note}
                                                                                    </TableCell>



                                                                                </TableRow>




                                                                            </Fragment>
                                                                        ))}
                                                                    </TableBody>
                                                                </Table>

                                                                : null
                                                        }

                                                    </div>

                                                    <div className="pt-3 mx-8">
                                                        <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                            <div className="font-medium">Purpose</div>
                                                            <div className="font-semibold ">{specifyPurposeValue}</div>
                                                        </div>
                                                        <div className="text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                            <div className="font-medium">Funding Account</div>


                                                            {
                                                                fundingAccounts.map((currentItem, index) => {
                                                                    return (
                                                                        <div key={index}>
                                                                            <div className="flex items-center flex-wrap justify-between my-3">
                                                                                <div className="font-light">Department</div>
                                                                                <div className="font-semibold ">{currentItem.fundingAccount?.name}</div>
                                                                            </div>
                                                                            <div className="flex justify-between">
                                                                                <div className="font-light">Remarks</div>
                                                                                <div className="font-semibold ">{currentItem.remarks}</div>
                                                                            </div>
                                                                            <div className="flex justify-between">
                                                                                <div className="font-light">Program Account #</div>
                                                                                <div className="font-semibold ">{currentItem.programAccountNumber}</div>
                                                                            </div>

                                                                            <div className="flex justify-between">
                                                                                <div className="font-light">Percentage</div>
                                                                                <div className="font-semibold ">{currentItem.percentageValue}</div>
                                                                            </div>

                                                                        </div>
                                                                    )
                                                                })
                                                            }


                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                    }




                                    <div className='grid grid-cols-1 gap-4'>

                                        {
                                            (showReport) ?
                                                <button onClick={handlePrint} className="bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-white flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                    <i className="mr-3 gusd-print-outline"></i><span>Print / Download</span>
                                                </button> :
                                                <button
                                                    onClick={() => setShowReport(true)}
                                                    className="bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-white flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                    <i className="mr-3 gusd-document"></i><span>Show Report</span>
                                                </button>

                                        }

                                    </div>

                                    <div style={{ display: "none" }} >
                                        <div ref={componentRef}>
                                            <div className="border m-4">
                                                <div className='text-center py-8'>
                                                    <Link to={""}><Image src={logoImg} width={"104"} height={"105"} imageClassName='m-auto' /></Link>
                                                    <div>
                                                        <div className="font-bold text-lg">GLENDALE UNIFIED SCHOOL DISTRICT</div>
                                                        <div className="font-semibold text-base">Preparing our students for their future</div>
                                                        <div className="font-light text-sm">
                                                            <div>Office of the Chief Human Resources & Operations Officer</div>
                                                            <div>223 North Jackson St. Glendale, California 91206-4380</div>
                                                            <div>Telephone:818-241-3111,Ext.1256 Fax:818-547-3207</div>
                                                        </div>
                                                    </div>
                                                    <div className="my-4 font-bold text-xl">
                                                        Substitute Request - Certificated
                                                    </div>
                                                </div>

                                                <div className="pt-3 mx-8">
                                                    <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                        <div className="font-medium">School or Department </div>
                                                        <div className="font-semibold ">{selectedSchool?.name}</div>
                                                    </div>
                                                    <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                        <div className="font-medium">Date </div>
                                                        <div className="font-semibold ">{moment(initiateNewReportDate).format('MM/DD/YYYY')}</div>
                                                    </div>

                                                    <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                        <div className="font-medium">Status </div>
                                                        <Tag severity="" value={SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_SITE_ADMIN} className="" style={{ background: '#EBFFF3', color: '#003D19' }}></Tag>
                                                        {/* <div >Approved</div> */}
                                                    </div>
                                                </div>


                                                <div>


                                                    {
                                                        (teachers.length > 0) ?

                                                            <Table className="certificatedPrintTable">
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell>Teacher(s) Name</TableCell>
                                                                        <TableCell>Date(s) Needed</TableCell>
                                                                        <TableCell>Indicate If</TableCell>
                                                                        <TableCell>Grade(element) or Subject(second)</TableCell>
                                                                        <TableCell>Notes</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>

                                                                    {teachers.map((item, i) => (
                                                                        <Fragment>
                                                                            <TableRow>
                                                                                <TableCell className="bg-[#F2F4F7]"
                                                                                >
                                                                                    {item.teacherName !== undefined ? item.teacherName.name : ''}
                                                                                </TableCell>
                                                                                <TableCell className="w-[180px]">
                                                                                    {item.datesNeeded.map((date, detailIndex) => (

                                                                                        <TableRow className="bg-[#F2F4F7]">
                                                                                            <TableCell>{moment(date).format('MM/DD/YYYY')}</TableCell>
                                                                                        </TableRow>
                                                                                    ))}
                                                                                </TableCell>
                                                                                <TableCell className="bg-[#F2F4F7]"
                                                                                >
                                                                                    {item.indicateIf !== undefined ? item.indicateIf.name : ''}
                                                                                </TableCell>
                                                                                <TableCell className="bg-[#F2F4F7]"
                                                                                >
                                                                                    {item.gradeOrSubject}
                                                                                </TableCell>
                                                                                <TableCell className="bg-[#F2F4F7]"
                                                                                >
                                                                                    {item.note}
                                                                                </TableCell>



                                                                            </TableRow>




                                                                        </Fragment>
                                                                    ))}
                                                                </TableBody>
                                                            </Table>

                                                            : null
                                                    }

                                                </div>

                                                <div className="pt-3 mx-8">
                                                    <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                        <div className="font-medium">Purpose</div>
                                                        <div className="font-semibold ">{specifyPurposeValue}</div>
                                                    </div>
                                                    <div className="text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                        <div className="font-medium">Funding Account</div>


                                                        {
                                                            fundingAccounts.map((currentItem, index) => {
                                                                return (
                                                                    <div key={index}>
                                                                        <div className="flex items-center flex-wrap justify-between my-3">
                                                                            <div className="font-light">Department</div>
                                                                            <div className="font-semibold ">{currentItem.fundingAccount?.name}</div>
                                                                        </div>
                                                                        <div className="flex justify-between">
                                                                            <div className="font-light">Remarks</div>
                                                                            <div className="font-semibold ">{currentItem.remarks}</div>
                                                                        </div>
                                                                        <div className="flex justify-between">
                                                                            <div className="font-light">Program Account #</div>
                                                                            <div className="font-semibold ">{currentItem.programAccountNumber}</div>
                                                                        </div>

                                                                        <div className="flex justify-between">
                                                                            <div className="font-light">Percentage</div>
                                                                            <div className="font-semibold ">{currentItem.percentageValue}</div>
                                                                        </div>

                                                                    </div>
                                                                )
                                                            })
                                                        }


                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Dialog>
                    {/* preview popup end */}


                </div>

            </Layout>
        </>

    ) : (
        <Login sessionExpired={1} />
    );
}

export default InitiateNewSubstituteRequestCertificated